export const translations = {
  fr: {
    tagline: "The link between musicians",
    hero_title_1: "L'espace de votre",
    hero_title_2: "groupe musical",
    hero_sub: "Bibliothèque de partitions, audios et vidéos, agenda, présences, setlists, inventaire : tout votre Pipe Band ou Bagad au même endroit.",
    trial_line: "Essai gratuit de 3 mois pour chaque nouveau groupe.",
    tab_login: "Connexion",
    tab_register: "Nouveau compte",
    tab_activate: "Première connexion",
    id_label: "ID",
    id_placeholder: "prenom@dimgroupe",
    password_label: "Mot de passe",
    remember_me: "Rester connecté",
    forgot_password: "Mot de passe oublié ?",
    forgot_info: "Contactez un administrateur de votre groupe : il réinitialisera votre accès. Vous pourrez ensuite utiliser « Première connexion ».",
    connect: "CONNECTER",
    connecting: "Connexion…",
    group_creation: "Création du groupe",
    group_creation_personal: "Création de l'espace perso",
    group_creation_school: "Création de l'espace éducateur",
    group_name: "Nom du groupe",
    diminutif: "Diminutif",
    style_label: "Style",
    custom_style: "Style personnalisé",
    logo_optional: "Logo (facultatif)",
    language: "Langue",
    next: "SUIVANT",
    back: "Retour",
    admin_profile: "Votre profil administrateur",
    firstname: "Prénom",
    lastname: "Nom",
    instrument_label: "Instrument / Pratique",
    create_group: "CRÉER LE GROUPE",
    creating: "Création…",
    first_connection: "Première connexion",
    admin_id_label: "ID créé par l'administrateur",
    create_password: "Créez votre mot de passe",
    confirmation: "Confirmation",
    activate: "ACTIVER",
    activating: "Activation…",
    your_id_will_be: "Votre ID sera :",

    // Commun
    "common.save": "Enregistrer",
    "common.saving": "Enregistrement…",
    "common.cancel": "Annuler",
    "common.delete": "Supprimer",
    "common.edit": "Modifier",
    "common.rename": "Renommer",
    "common.add": "Ajouter",
    "common.close": "Fermer",
    "nav.help": "Aide",
    "common.uploading": "Envoi en cours",
    "help.title": "Centre d'aide",
    "help.subtitle": "Guides détaillés pour profiter de toutes les fonctions de RANNEA.",
    "help.replay": "Revoir le tutoriel",
    "help.replay_hint": "Rejouez la visite guidée de démarrage à tout moment.",
    "help.guided_tour": "Visite interactive",
    "tour.done": "Terminer",
    "common.confirm": "Confirmer",
    "common.back": "Retour",
    "common.search": "Rechercher",
    "common.loading": "Chargement…",
    "common.yes": "Oui",
    "common.no": "Non",
    "common.maybe": "Peut-être",
    "common.logout": "Se déconnecter",
    "common.group_logo": "Logo du groupe",
    "common.optional": "facultatif",
    "common.availability_saved": "Disponibilité enregistrée",

    // Navigation
    "nav.dashboard": "Tableau de bord",
    "nav.library": "Bibliothèque",
    "nav.documents": "Documents",
    "nav.agenda": "Agenda",
    "nav.presence": "Présence",
    "nav.inventory": "Inventaire",
    "nav.favorites": "Favoris",
    "nav.setlists": "Setlist",
    "nav.purchases": "Achats",
    "achats.dev_title": "En cours de développement",
    "achats.dev_text": "Ce module sera bientôt disponible. Merci de votre patience !",
    "shop.title": "Achats",
    "shop.subtitle": "Buvette, tenues, merch, cotisations…",
    "shop.catalog": "Boutique",
    "shop.manage": "Achats & Encaissements — gestion",
    "shop.manage_short": "Gestion",
    "shop.back_catalog": "Toutes les catégories",
    "shop.empty_catalog": "Aucune catégorie pour le moment.",
    "shop.empty_items": "Aucun article dans cette catégorie.",
    "shop.items_count": "{count} article(s)",
    "shop.cat_new": "Nouvelle catégorie",
    "shop.cat_edit": "Modifier la catégorie",
    "shop.cat_name": "Nom de la catégorie",
    "shop.icon": "Icône",
    "shop.allow_tab": "Autoriser l'ardoise",
    "shop.allow_immediate": "Autoriser le paiement immédiat",
    "shop.inactive_badge": "Désactivée",
    "shop.item_new": "Nouvel article",
    "shop.item_edit": "Modifier l'article",
    "shop.item_name": "Nom de l'article",
    "shop.item_desc": "Description (facultative)",
    "shop.price": "Prix (€)",
    "shop.item_active": "Article actif",
    "shop.item_tab_mode": "Ardoise pour cet article",
    "shop.tab_inherit": "Comme la catégorie",
    "shop.yes": "Oui",
    "shop.no": "Non",
    "shop.image": "Image (facultative)",
    "shop.tab_badge": "Ardoise",
    "shop.pay_badge": "Paiement",
    "shop.cat_created": "Catégorie créée",
    "shop.cat_updated": "Catégorie mise à jour",
    "shop.item_created": "Article créé",
    "shop.item_updated": "Article mis à jour",
    "shop.delete_cat_desc": "Supprimer la catégorie « {name} » et ses articles ? (Impossible si un historique existe — désactivez-la dans ce cas.)",
    "shop.delete_item_desc": "Supprimer l'article « {name} » ? (Impossible si un historique existe — désactivez-le dans ce cas.)",
    "shop.tab_title": "Mon ardoise",
    "shop.finance_view": "Encaissements",
    "shop.open_tabs": "Ardoises ouvertes",
    "shop.balance_due": "Solde dû",
    "shop.balance_none": "Rien à régler",
    "shop.cart_validate": "Mettre sur mon ardoise",
    "shop.cart_added": "Ajouté à votre ardoise",
    "shop.tab_empty": "Aucun achat pour le moment.",
    "shop.tab_open": "À régler",
    "shop.tab_settled": "Réglée",
    "shop.tab_cancelled": "Annulée",
    "shop.all_status": "Tout",
    "shop.no_open_tabs": "Aucun achat à afficher.",
    "shop.settle": "Encaisser",
    "shop.settle_method": "Moyen de règlement",
    "shop.settle_amount": "Montant réglé (€)",
    "shop.settle_note": "Note (facultative)",
    "shop.method_cash": "Espèces",
    "shop.method_check": "Chèque",
    "shop.method_transfer": "Virement",
    "shop.settle_done": "Règlement enregistré",
    "shop.cancel_purchase": "Annuler",
    "shop.cancel_reason": "Motif de l'annulation",
    "shop.cancel_done": "Achat annulé",
    "shop.cancel_hint": "L'annulation est tracée (motif, auteur, date). L'achat n'est jamais supprimé.",
    "shop.remaining": "Reste",
    "shop.settlements": "Règlements",
    "shop.cancelled_by": "Annulée par {name}",
    "shop.qr_code": "QR code",
    "shop.qr_title": "QR code — {name}",
    "shop.qr_hint": "À afficher près de la caisse : le membre scanne le code, se connecte si besoin, et arrive directement sur cette catégorie.",
    "shop.qr_copy": "Copier le lien",
    "shop.qr_download": "Télécharger (PNG)",
    "shop.qr_invalid": "Ce lien ne correspond à aucune catégorie active de votre groupe.",
    "shop.pots_title": "Cagnottes",
    "shop.pot_contribute": "Contribuer",
    "shop.pot_collected": "{amount} collectés",
    "shop.pot_goal_label": "Objectif : {amount}",
    "shop.pot_goal_reached": "Objectif atteint !",
    "shop.pot_free": "Contribution libre",
    "shop.pot_amount": "Montant de votre contribution (€)",
    "shop.pot_tab_hint": "Le montant est ajouté à votre ardoise ; vous le réglez au trésorier comme à la buvette.",
    "shop.pot_contributed": "Contribution ajoutée à votre ardoise",
    "shop.pot_new": "Nouvelle cagnotte",
    "shop.pot_edit": "Modifier la cagnotte",
    "shop.pot_name": "Nom de la cagnotte",
    "shop.pot_desc": "Description (facultative)",
    "shop.pot_goal": "Objectif (€, facultatif)",
    "shop.pot_closed": "Clôturée",
    "shop.pot_created": "Cagnotte créée",
    "shop.pot_updated": "Cagnotte mise à jour",
    "shop.pot_empty": "Aucune cagnotte pour le moment.",
    "shop.delete_pot_desc": "Supprimer la cagnotte « {name} » ? (Impossible si des contributions existent — clôturez-la dans ce cas.)",
    "shop.my_fee": "Ma cotisation",
    "shop.fees_summary": "Cotisations",
    "shop.fees_goto": "Gérer les cotisations",
    "shop.treasury": "Trésorerie",
    "shop.period_month": "Mois en cours",
    "shop.period_season": "Saison en cours",
    "shop.period_all": "Tout",
    "shop.date_from": "Du",
    "shop.date_to": "au",
    "shop.received_period": "Encaissé sur la période",
    "shop.open_tabs_total": "Ardoises ouvertes",
    "shop.refunds_due": "Remboursements dus",
    "shop.sales_count": "{count} achat(s) • {amount} vendus sur la période",
    "shop.by_method": "Par moyen de règlement",
    "shop.debtors": "Soldes ouverts par membre",
    "shop.refund_to": "À rembourser à {name}",
    "shop.no_refunds": "Aucun remboursement en attente.",
    "shop.mark_refunded": "Marquer remboursé",
    "shop.refunded_done": "Remboursement marqué comme effectué",
    "shop.export_csv": "Exporter les encaissements (CSV)",
    "shop.filter_member": "Tous les membres",
    "shop.online_payments": "Paiements en ligne",
    "shop.test_mode_badge": "MODE TEST",
    "shop.pay_connect": "Activer les paiements en ligne",
    "shop.pay_resume": "Reprendre l'onboarding Stripe",
    "shop.pay_active": "Actif — compte Stripe connecté",
    "shop.pay_test_shared": "Actif — compte de test partagé (sandbox)",
    "shop.pay_pending": "Onboarding Stripe à terminer",
    "shop.pay_none": "Non configuré",
    "shop.pay_hint": "Mode test : carte 4242 4242 4242 4242, date future, CVC quelconque. L'argent arrive sur le compte Stripe du groupe (Stripe Connect).",
    "shop.pay_tab": "Régler en ligne (test)",
    "shop.pay_online": "Payer en ligne (test)",
    "shop.buy_now": "Acheter",
    "shop.pay_success": "Paiement en ligne confirmé (mode test)",
    "shop.pay_cancelled": "Paiement annulé — rien n'a été débité.",
    "shop.connect_returned": "Retour de Stripe — statut des paiements mis à jour.",
    "shop.live_mode_badge": "LIVE",
    "shop.pay_hint_live": "Paiements réels actifs — l'argent arrive sur le compte Stripe du groupe (Stripe Connect).",
    "shop.pay_tab_live": "Régler en ligne",
    "shop.pay_online_live": "Payer en ligne",
    "shop.pay_success_live": "Paiement en ligne confirmé",
    "shop.prod_title": "Passage en production",
    "shop.prod_intro": "Les paiements sont en mode test (aucun argent réel). Pour encaisser de vrais paiements :",
    "shop.prod_step1": "Réclamez le sandbox Emergent (ou créez votre compte Stripe) et terminez la vérification d'identité.",
    "shop.prod_step2": "Activez Stripe Connect dans le Dashboard (Paramètres → Connect).",
    "shop.prod_step3": "Ajoutez vos clés live (pk_live / sk_live) et le secret du webhook live dans les variables d'environnement, puis STRIPE_MODE=live.",
    "shop.prod_step4": "Enregistrez l'endpoint webhook live (/api/stripe/webhook) et validez avec un paiement réel de 1 €.",
    "shop.prod_guide": "Guide complet pas-à-pas : docs/PRODUCTION_STRIPE.md",
    "shop.method_online": "En ligne",
    "shop.refunds_show_all": "Tout afficher ({count})",
    "shop.refunds_show_less": "Réduire",
    "shop.total": "Total",
    "shop.onsite": "Paiement sur place",
    "shop.onsite_hint": "Composez l'addition : le membre paiera en scannant le QR avec son téléphone (carte, Apple Pay, Google Pay).",
    "shop.onsite_show_qr": "Afficher le QR de paiement",
    "shop.onsite_scan": "Le membre scanne ce code avec son téléphone et paie en ligne.",
    "shop.onsite_waiting": "En attente du paiement…",
    "shop.onsite_paid": "Paiement reçu !",
    "shop.onsite_abandon": "Abandonner la vente",
    "shop.onsite_abandon_reason": "Vente comptoir abandonnée",
    "shop.onsite_new": "Nouvelle vente",
    "shop.onsite_close": "Fermer",
    "pay.thanks_title": "Paiement confirmé",
    "pay.thanks_body": "Merci ! Vous pouvez fermer cette page.",
    "pay.cancelled_title": "Paiement annulé",
    "pay.cancelled_body": "Rien n'a été débité. Vous pouvez fermer cette page.",
    "nav.users": "Utilisateurs",
    "nav.settings": "Paramètres",
    "nav.home": "Accueil",

    // Catégories d'événements
    "cat.repetition": "Répétition",
    "cat.prestation": "Prestation",
    "cat.autre": "Autre",

    // Layout / cadre
    "layout.greeting": "Bonjour {name}",
    "layout.my_groups": "Mes groupes",
    "layout.my_space": "Mon espace",
    "layout.other_accounts": "Autres comptes sur cet appareil",
    "layout.current_group": "Groupe actif",
    "layout.add_group": "Ajouter un groupe",
    "layout.add_group_identity": "Ce compte RANNEA se connecte avec son e-mail depuis la page de connexion. Une fois connecté, la bascule se fait via « Mes groupes ».",
    "layout.add_group_title": "Connecter un autre groupe",
    "layout.add_group_desc": "Saisissez l'identifiant de votre compte dans l'autre groupe (ex. prenom@autregroupe). La bascule se fera sans déconnexion.",
    "layout.notifications": "Notifications",
    "layout.mark_all_read": "Tout marquer lu",
    "layout.no_notifications": "Aucune notification",
    "layout.reminder_title": "Prochain événement : êtes-vous disponible ?",
    "layout.badge_trial_s": "Essai gratuit : {d} jour restant",
    "layout.badge_trial_p": "Essai gratuit : {d} jours restants",
    "layout.badge_pastdue_s": "À renouveler : {d} jour avant blocage",
    "layout.badge_pastdue_p": "À renouveler : {d} jours avant blocage",
    "layout.sub_active": "Abonnement actif",
    "layout.sub_expired": "Abonnement expiré",
    "layout.trial_prefix": "Essai gratuit",
    "layout.trial_inner_s": "{d} jour restant",
    "layout.trial_inner_p": "{d} jours restants",
    "layout.trial_cta": "Choisir un abonnement",
    "layout.pastdue_prefix": "Abonnement à renouveler",
    "layout.pastdue_inner_s": "blocage dans {d} jour",
    "layout.pastdue_inner_p": "blocage dans {d} jours",
    "layout.renew": "Renouveler",
    "layout.suspended_title": "Groupe suspendu",
    "layout.expired_title": "Abonnement expiré",
    "layout.suspended_text": "L'accès du groupe est suspendu par la plateforme. Contactez le support pour plus d'informations.",
    "layout.expired_text_1": "L'accès du groupe est suspendu.",
    "layout.expired_text_data": "Vos données sont conservées",
    "layout.expired_text_2": "— réactivez l'abonnement pour retrouver l'accès complet.",
    "layout.reactivate": "Réactiver l'abonnement",
    "layout.contact_admin": "Contactez l'administrateur de votre groupe pour réactiver l'accès.",
    "layout.more_tabs": "Plus d'onglets",

    // Tableau de bord
    "dash.stat_members": "Membres actifs",
    "dash.stat_pieces": "Morceaux",
    "dash.stat_documents": "Documents",
    "dash.stat_upcoming": "Événements à venir",
    "dash.next_event": "Prochain événement",
    "dash.members_available": "membre(s) disponible(s)",
    "dash.my_availability": "Ma disponibilité",
    "dash.program": "Programme",
    "dash.no_upcoming": "Aucun événement à venir.",
    "dash.upcoming_title": "À venir — 5 prochains événements",
    "dash.recent_title": "Activité récente",
    "dash.no_recent": "Aucun fichier ouvert récemment.",

    // Disponibilité
    "avail.yes": "Oui",
    "avail.maybe": "Peut-être",
    "avail.no": "Non",
    "avail.none": "Pas répondu",

    // Confirmation
    "confirm.title": "Confirmer la suppression",
    "confirm.cancel": "Annuler",
    "confirm.delete": "Supprimer",

    // Favoris
    "fav.title": "Mes favoris",
    "fav.subtitle": "Vos favoris sont strictement personnels.",
    "fav.empty": "Aucun favori. Ajoutez des morceaux, médias ou documents avec l'icône cœur.",
    "fav.type_piece": "Morceaux",
    "fav.type_version": "Versions",
    "fav.type_file": "Médias & fichiers",
    "fav.type_document": "Documents",

    // Présences
    "pres.title": "Présences",
    "pres.subtitle": "Cliquez sur vos propres cellules pour modifier votre disponibilité.",
    "pres.full_view": "Matrice complète",
    "pres.present_label": "présents",
    "pres.tab_upcoming": "À venir",
    "pres.tab_done": "Effectuée",
    "pres.loading": "Chargement des présences…",
    "pres.zoom_out": "Zoom arrière",
    "pres.zoom_in": "Zoom avant",
    "pres.member": "Membre",
    "pres.you": "(vous)",
    "pres.no_instrument": "Sans instrument",
    "pres.empty_upcoming": "Aucun événement à venir.",
    "pres.empty_past": "Aucun événement passé.",

    // Setlists
    "setl.empty": "Aucune setlist.",
    "setl.new_placeholder": "Nouvelle setlist",
    "setl.select_prompt": "Sélectionnez une setlist.",
    "setl.no_pieces": "Aucun morceau dans cette setlist.",
    "setl.piece_deleted": "Morceau supprimé",
    "setl.add_piece_placeholder": "Ajouter un morceau de la Bibliothèque…",
    "setl.delete_title": "Supprimer la setlist ?",
    "setl.delete_desc": "« {name} » sera supprimée définitivement.",

    // Utilisateurs
    "usr.role_admin": "Administrateur",
    "usr.role_music_leader": "Responsable musical",
    "usr.role_treasurer": "Trésorier",
    "usr.role_musician": "Musicien",
    "usr.role_member": "Membre non musicien",
    "usr.role_prof": "Professeur",
    "usr.role_student": "Élève",
    "usr.role_updated": "Rôle mis à jour",
    "usr.instrument_updated": "Instrument mis à jour",
    "usr.deactivated": "Compte désactivé (données conservées)",
    "usr.reactivated": "Compte réactivé",
    "usr.reset_done": "Accès réinitialisé : {name} devra utiliser « Première connexion » pour créer un nouveau mot de passe.",
    "usr.title": "Utilisateurs",
    "usr.new": "NOUVEL UTILISATEUR",
    "usr.search_placeholder": "Rechercher un membre…",
    "usr.show_inactive": "Afficher les comptes désactivés",
    "usr.col_name": "Nom",
    "usr.col_role": "Rôle",
    "usr.col_instrument": "Instrument/Pratique",
    "usr.col_actions": "Actions",
    "usr.you": "(vous)",
    "usr.pending": "(en attente d'activation)",
    "usr.disabled": "(désactivé)",
    "usr.none_found": "Aucun membre trouvé.",
    "usr.create_title": "Nouvel utilisateur",
    "usr.create_desc": "Le membre recevra un e-mail d'invitation sécurisé pour rejoindre le groupe.",
    "usr.created_msg": "Compte créé. Communiquez cet ID au membre :",
    "usr.group_label": "Groupe : {name}",
    "usr.create_submit": "Créer le membre",
    "usr.choose": "Choisir…",
    "usr.reset_title": "Réinitialiser le mot de passe (le membre refera « Première connexion »)",
    "usr.deactivate_title": "Désactiver (conserve les données)",
    "usr.reactivate_title": "Réactiver",
    "usr.delete_title_attr": "Supprimer définitivement",
    "usr.delete_title": "Suppression définitive",
    "usr.delete_desc": "Le compte de {name} sera définitivement retiré de la base de données. Il n'existe pas de corbeille. Pour conserver ses données, utilisez plutôt la désactivation.",

    // Agenda
    "agd.updated": "Événement mis à jour",
    "agd.created": "Événement créé",
    "agd.created_recurrent": "Événements récurrents créés",
    "agd.program_saved": "Programme enregistré",
    "agd.piece_fallback": "Morceau",
    "agd.new_event": "Nouvel événement",
    "agd.remind_avail": "Relancer les disponibilités",
    "agd.remind_avail_done": "{n} membre(s) relancé(s)",
    "agd.remind_avail_none": "Tout le monde a déjà répondu",
    "agd.presence_shortcut": "Tableau des présences",
    "agd.edit_event": "Modifier l'événement",
    "agd.loading": "Chargement de l'agenda…",
    "agd.past_events": "Événements passés",
    "agd.filter_all": "Tous",
    "agd.type_label": "Type d'événement",
    "agd.date": "Date",
    "agd.start": "Début",
    "agd.end": "Fin",
    "agd.location": "Lieu",
    "agd.location_search_placeholder": "Nom, adresse, ville, code postal…",
    "agd.location_no_result": "Aucun résultat — la saisie manuelle est conservée.",
    "agd.location_clear_geo": "Retirer la géolocalisation (conserver le texte)",
    "agd.itinerary": "Itinéraire",
    "agd.share": "Partager",
    "agd.add_calendar": "Ajouter au calendrier",
    "agd.ics_downloaded": "Fichier calendrier téléchargé — ouvrez-le pour ajouter l'événement",
    "agd.share_text": "{title} — {date}",
    "agd.link_copied": "Lien de l'événement copié !",
    "agd.copy_link": "Copier le lien",
    "install.title": "Installer l'application RANNEA",
    "install.subtitle": "Accédez à RANNEA en un clic, comme une vraie application.",
    "install.question": "Quel appareil utilisez-vous ?",
    "install.detected": "Détecté",
    "install.later": "Plus tard",
    "install.now": "Installer maintenant",
    "install.direct_hint": "Installation directe sur cet appareil, sans manipulation.",
    "install.guide_title": "Ou suivez le guide :",
    "install.done_hint": "Après installation, RANNEA s'ouvre directement sur votre espace si vous restez connecté.",
    "install.device.pc": "PC (Windows)",
    "install.device.mac": "Mac",
    "install.device.ios": "iPhone / iPad",
    "install.device.android": "Android",
    "install.guide.pc": "1. Cliquez sur l'icône d'installation (petit écran avec flèche) à droite de la barre d'adresse.\n2. Sinon : menu ⋮ en haut à droite → « Enregistrer et partager » → « Installer RANNEA ».\n3. Confirmez : l'icône RANNEA apparaît dans vos applications.",
    "install.guide.mac": "Avec Safari (macOS Sonoma ou +) :\n1. Ouvrez le menu Fichier → « Ajouter au Dock ».\n2. Confirmez : RANNEA apparaît dans votre Dock.\nAvec Chrome : cliquez sur l'icône d'installation à droite de la barre d'adresse, puis « Installer ».",
    "install.guide.ios_share": "Sur iPhone/iPad, l'installation passe obligatoirement par Safari.",
    "install.guide.ios": "1. Ouvrez cette adresse dans Safari.\n2. Touchez le bouton Partager (carré avec flèche vers le haut).\n3. Faites défiler et touchez « Sur l'écran d'accueil ».\n4. Touchez « Ajouter » : l'icône RANNEA rejoint votre écran d'accueil.",
    "install.guide.android": "1. Touchez « Installer » si la bannière s'affiche, sinon : menu ⋮ en haut à droite.\n2. Choisissez « Ajouter à l'écran d'accueil » ou « Installer l'application ».\n3. Confirmez : l'icône RANNEA rejoint votre écran d'accueil.",
    "agd.open_navigation": "Ouvrir dans l'application de navigation",
    "agd.nav_choose": "Ouvrir l'itinéraire avec…",
    "agd.nav_apple": "Plans",
    "agd.nav_web": "Voir sur la carte web (OpenStreetMap)",
    "agd.this_week": "Cette semaine",
    "agd.next_week": "Semaine prochaine",
    "agd.filter_unanswered": "Sans réponse",
    "agd.unanswered_state": "Réponse attendue",
    "agd.all_answered": "Aucun événement en attente de réponse.",
    "agd.organized_by": "Organisé par {name}",
    "agd.participate": "Participer",
    "agd.decline": "Refuser",
    "agd.responses_title": "Réponses",
    "agd.resp_yes_label": "participant(s)",
    "agd.resp_pending_label": "en attente de réponse",
    "agd.resp_no_label": "refus",
    "agd.see_presences": "Voir les présences",
    "agd.event_not_found": "Événement introuvable.",
    "agd.description_label": "Description",
    "agd.edit_program": "Modifier le programme",
    "agd.delete_event": "Supprimer l'événement",
    "agd.delete_event_desc": "« {name} » et les réponses associées seront supprimés définitivement.",
    "agd.deleted": "Événement supprimé",
    "common.error": "Une erreur est survenue",
    "agd.cover_label": "Photo / Affiche",
    "agd.end_date": "Date de fin (facultatif)",
    "agd.date_range": "Du {start} au {end}",
    "agd.cover_add": "Ajouter une image",
    "agd.cover_remove": "Retirer l'image",
    "agd.title_label": "Titre (facultatif)",
    "agd.title_placeholder": "Ex. Concert de printemps",
    "agd.weather_later": "Météo disponible à l'approche de l'événement",
    "wx.clear": "Dégagé",
    "wx.partly": "Éclaircies",
    "wx.cloudy": "Nuageux",
    "wx.fog": "Brouillard",
    "wx.drizzle": "Bruine",
    "wx.rain": "Pluie",
    "wx.showers": "Averses",
    "wx.snow": "Neige",
    "wx.storm": "Orage",
    "agd.comments_title": "Commentaires",
    "agd.no_comments": "Aucun commentaire pour le moment.",
    "agd.comment_placeholder": "Écrire un commentaire…",
    "agd.comment_send": "Envoyer",
    "agd.comment_reply": "Répondre",
    "agd.comment_reply_to": "Réponse à {name}",
    "agd.comment_delete_desc": "Supprimer définitivement ce commentaire ?",
    "agd.time_now": "À l'instant",
    "agd.time_min": "Il y a {count} min",
    "agd.time_hours": "Il y a {count} h",
    "agd.time_days": "Il y a {count} j",
    "agd.notes_optional": "Notes (facultatif)",
    "agd.dress_label": "Tenue portée le jour J",
    "agd.dress_placeholder": "Ex. Tenue complète, kilt + gilet…",
    "agd.dress_items_label": "Articles de tenue (inventaire)",
    "agd.dress_prefix": "Tenue :",
    "agd.dress_items_prefix": "Articles de tenue :",
    "agd.recurrent": "Événement récurrent",
    "agd.recurrence_label": "Répétition",
    "agd.freq_daily": "Tous les jours",
    "agd.freq_weekly": "Toutes les semaines",
    "agd.freq_monthly": "Tous les mois",
    "agd.until": "Jusqu'au",
    "agd.setlist_label": "Setlist / programme musical",
    "agd.program_custom_label": "Programme sur mesure — pupitres & morceaux",
    "agd.no_setlist": "Aucune",
    "agd.checklist_label": "Checklist matériel",
    "agd.create_event": "Créer l'événement",
    "agd.create_recurrent": "Créer les événements",
    "agd.delete_title": "Supprimer l'événement ?",
    "agd.delete_desc": "« {name} » sera supprimé définitivement. Il n'existe pas de corbeille.",
    "agd.note_optional": "Note (facultatif)",
    "agd.axis_label": "Axe de travail",
    "agd.axis_placeholder": "Ensemble, Pipe…",
    "agd.piece_picker_label": "Morceau — catégorie → morceaux, recherche rapide",
    "agd.piece_search": "Rechercher un morceau…",
    "agd.no_category": "Sans catégorie",
    "agd.no_piece": "Aucun morceau",
    "agd.save_program": "Enregistrer le programme",
    "agd.program_create": "Créer un programme de répétition",
    "agd.program_linked": "Programme lié à la répétition",
    "agd.program_new": "Nouveau programme",
    "agd.program_name_ph": "Répétition hebdomadaire",
    "agd.mode_concert": "Mode Concert",
    "agd.mode_repetition": "Mode Répétition",
    "agd.pick": "Piocher",
    "agd.block": "Bloc",
    "agd.block_empty": "Aucun morceau dans ce bloc.",
    "agd.add_block": "Ajouter un bloc",
    "agd.block_rename_ph": "Nom du bloc",
    "agd.choose_piece": "Choisir un morceau",
    "agd.piece_search_ph": "Rechercher par nom, compositeur, tag…",
    "agd.all_styles": "Tous les styles",
    "agd.program_summary": "{n} morceaux · {mode}",
    "agd.piece_added": "Morceau ajouté au programme",
    "agd.program_reset": "Recréer le programme",
    "agd.switch_mode": "Changer de mode",
    "nset.title": "Notifications",
    "nset.desc": "Soyez informé des nouveautés de votre groupe : morceaux, documents et événements.",
    "nset.question": "Souhaitez-vous activer les notifications ?",
    "nset.yes": "Oui, activer",
    "nset.no": "Non merci",
    "nset.later_hint": "Vous pourrez modifier ce choix à tout moment dans Paramètres.",
    "nset.types_title": "Que souhaitez-vous recevoir ?",
    "nset.types_desc": "Choisissez les types de notifications à recevoir.",
    "nset.saved": "Préférences de notifications enregistrées",

    // Documents
    "docs.folder_created": "Dossier créé",
    "docs.renamed": "Renommé",
    "docs.deleted": "Supprimé définitivement",
    "docs.file_renamed": "Fichier renommé",
    "docs.import_done": "Import terminé",
    "docs.link_added": "Lien ajouté",
    "docs.search_placeholder": "Rechercher…",
    "docs.no_results": "Aucun résultat",
    "docs.folders_section": "Dossiers",
    "docs.files_section": "Fichiers",
    "docs.view_grid": "Vue grille",
    "docs.view_list": "Vue liste",
    "docs.tree_show": "Afficher l'arborescence",
    "docs.tree_hide": "Masquer l'arborescence",
    "docs.loading": "Chargement des documents…",
    "docs.no_folder": "Aucun dossier.",
    "docs.no_folder_create": " Créez votre premier dossier.",
    "docs.new_folder": "Nouveau dossier",
    "docs.new_subfolder": "Nouveau sous-dossier",
    "docs.select_folder": "Sélectionnez un dossier.",
    "docs.subfolder": "Sous-dossier",
    "docs.add_files": "Ajouter des fichiers",
    "docs.add_link": "Ajouter un lien",
    "docs.no_file": "Aucun fichier dans ce dossier.",
    "docs.no_file_hint": " Ajoutez ou glissez-déposez vos fichiers ici.",
    "docs.download": "Télécharger",
    "docs.create_folder_sr": "Créer un dossier ou sous-dossier",
    "docs.rename_folder_sr": "Renommer le dossier sélectionné",
    "docs.delete_folder_desc": "Ce dossier et tout son contenu seront supprimés définitivement. Il n'existe pas de corbeille.",
    "docs.add_link_sr": "Ajouter un lien externe au dossier",
    "docs.link_name": "Nom du lien",
    "docs.upload_names_title": "Nommer les fichiers avant ajout",
    "docs.upload_names_sr": "Renommer les fichiers avant import",
    "docs.import": "Importer",
    "docs.file_counter": "Fichier {i}/{total}",
    "docs.rename_file_title": "Renommer le fichier",
    "docs.fullscreen": "Plein écran",
    "docs.pdf_reader_sr": "Lecteur de document PDF",
    "common.create": "Créer",

    // Bibliothèque
    "lib.cat_created": "Catégorie créée",
    "lib.piece_updated": "Morceau mis à jour",
    "lib.piece_created": "Morceau créé",
    "lib.pupitre_added": "Pupitre ajouté",
    "lib.version_created": "Version créée avec ses pupitres",
    "lib.class_partition": "Partitions PDF",
    "lib.class_audio": "Audios",
    "lib.class_video": "Vidéos",
    "lib.class_link": "Liens",
    "lib.categories": "Catégories",
    "lib.new_category": "Nouvelle catégorie",
    "lib.new_category_sr": "Créer une catégorie de morceaux",
    "lib.category_name_placeholder": "Nom (ex. 2/4, Hornpipe, Suite…)",
    "lib.all_pieces": "Tous les morceaux",
    "lib.zone_bagad": "Bagad",
    "lib.zone_pipeband": "Pipe Band",
    "lib.discipline_label": "Discipline",
    "lib.discipline_common": "Commune (les deux)",
    "lib.all": "Tous",
    "lib.new_piece": "Nouveau morceau",
    "lib.loading": "Chargement de la bibliothèque…",
    "lib.no_piece": "Aucun morceau.",
    "lib.no_piece_create": " Créez d'abord une catégorie.",
    "lib.versions_count": "version(s)",
    "lib.back_to_pieces": "Retour aux morceaux",
    "lib.piece_fav": "Morceau favori",
    "lib.edit_piece": "Modifier le morceau",
    "lib.delete_piece": "Supprimer le morceau",
    "lib.no_meta": "Aucune métadonnée.",
    "lib.history_prefix": "Historique — ",
    "lib.version_fav": "Version favorite",
    "lib.rename_version": "Renommer la version",
    "lib.delete_version": "Supprimer la version",
    "lib.no_version": "Aucune version.",
    "lib.no_version_hint": " Créez une version et cochez les pupitres concernés.",
    "lib.pupitre_add": "+ Pupitre",
    "lib.pupitre_prefix": "Pupitre",
    "lib.rename_pupitre": "Renommer le pupitre",
    "lib.remove_pupitre": "Retirer le pupitre",
    "lib.no_file": "Aucun fichier.",
    "lib.preview_empty_1": "Sélectionnez un média",
    "lib.preview_empty_2": "pour l'aperçu",
    "lib.pdf_reader_sr": "Lecteur de partition PDF",
    "lib.new_pupitre": "Nouveau pupitre",
    "lib.new_pupitre_sr": "Ajouter un pupitre à la version sélectionnée",
    "lib.group_instruments": "Instruments du groupe",
    "lib.custom_name": "Nom personnalisé…",
    "lib.new_version": "Nouvelle version",
    "lib.new_version_desc": "Cochez les pupitres (instruments) concernés par cette version.",
    "lib.version_name_placeholder": "Nom de la version (ex. 2026)",
    "lib.version_pupitres_label": "Pupitres — instruments du groupe",
    "lib.no_instruments_hint": "Aucun instrument défini — l'administrateur peut en ajouter dans Paramètres → Groupe.",
    "lib.remove_named": "Retirer {name}",
    "lib.custom_pupitre_placeholder": "Autre pupitre (personnalisé)…",
    "lib.create_version": "Créer la version",
    "lib.rename_node_sr": "Renommer l'élément sélectionné",
    "lib.delete_desc": "« {name} » et tout son contenu seront supprimés définitivement. Il n'existe pas de corbeille.",
    "lib.add_link_sr": "Ajouter un lien externe (YouTube, site web…)",
    "lib.delete_pupitre_files": "Le pupitre « {name} » contient {count} fichier(s). Sa suppression entraînera également la suppression de ces fichiers. Voulez-vous continuer ?",
    "lib.delete_pupitre_empty": "Supprimer le pupitre « {name} » ? Il ne contient aucun fichier.",
    "lib.download": "Télécharger",
    "lib.share": "Partager",
    "lib.print": "Imprimer",
    "lib.link_copied": "Lien copié dans le presse-papiers",

    // Paramètres
    "param.font_applied": "Taille du texte appliquée",
    "param.profile_updated": "Profil mis à jour",
    "param.pwd_mismatch": "Les mots de passe ne correspondent pas",
    "param.pwd_changed": "Mot de passe modifié",
    "param.group_updated": "Groupe mis à jour",
    "param.catimg_updated": "Image de catégorie mise à jour",
    "param.logo_updated": "Logo mis à jour",
    "param.instruments_updated": "Instruments mis à jour",
    "param.subs_updated": "Sous-catégories mises à jour",
    "param.axes_updated": "Axes de travail mis à jour",
    "param.push_enabled": "Notifications push activées sur cet appareil",
    "param.push_failed": "Activation impossible",
    "param.theme_applied": "Thème appliqué",
    "param.sub_activated": "Abonnement activé (paiement simulé)",
    "param.eyedropper_unsupported": "La pipette n'est pas supportée par ce navigateur",
    "param.tab_profile": "Profil",
    "param.tab_group": "Groupe",
    "param.tab_theme": "Thème",
    "param.tab_subscription": "Abonnement",
    "param.my_profile": "Mon profil",
    "param.role_hint": "rôle attribué par l'administrateur",
    "param.instrument_one": "Instrument / Pratique (un seul)",
    "param.password": "Mot de passe",
    "param.pwd_current": "Mot de passe actuel",
    "param.pwd_new": "Nouveau mot de passe",
    "param.change_password": "Modifier le mot de passe",
    "param.email_title": "Adresse e-mail",
    "param.email_current": "Adresse actuelle",
    "param.email_new": "Nouvelle adresse e-mail",
    "param.email_send_code": "Recevoir le code de vérification",
    "param.email_code_sent": "Code envoyé à {email}",
    "param.email_verify": "Valider le changement",
    "param.email_changed": "Adresse e-mail modifiée !",
    "param.email_hint": "Le code est envoyé à la nouvelle adresse. L'ancienne recevra une notification de sécurité.",
    "param.push_title": "Notifications push",
    "param.push_desc": "Alertes sur cet appareil, même application fermée.",
    "param.push_on": "Activées",
    "param.push_denied": "Bloquées par le navigateur",
    "param.cal_title": "Synchronisation calendrier",
    "param.cal_desc": "Tout l'agenda du groupe directement dans le calendrier de votre téléphone (iPhone, Android, Google Calendar…). Les modifications d'événements apparaissent automatiquement.",
    "param.cal_button": "S'abonner au calendrier",
    "param.cal_hint": "Le lien s'ouvre dans l'app Calendrier de votre appareil. Vous pouvez aussi le copier pour l'ajouter manuellement.",
    "param.cal_copied": "Lien d'abonnement copié",
    "param.push_unsupported": "Non supportées ici",
    "param.activate": "Activer",
    "param.notify_for": "Me notifier pour",
    "param.notif_pieces": "Nouveaux morceaux / médias",
    "param.notif_documents": "Nouveaux documents",
    "param.notif_events_created": "Événements créés",
    "param.notif_events_updated": "Événements modifiés",
    "param.display": "Affichage",
    "param.font_size": "Taille du texte",
    "param.font_size_hint": "L'aperçu est immédiat pendant le réglage ; la taille n'est enregistrée que lorsque vous cliquez sur Appliquer.",
    "param.apply": "Appliquer",
    "param.apply_caps": "APPLIQUER",
    "param.group_identity": "Identité du groupe",
    "param.logo_label": "Logo",
    "param.change_logo": "Changer le logo",
    "param.catimg_title": "Images de fond par catégorie d'événement",
    "param.catimg_desc": "Affichées en vignette dans l'agenda et en arrière-plan de la carte « Prochain événement » du tableau de bord.",
    "agd.cover_default_title": "Image par défaut ?",
    "agd.cover_default_q": "Enregistrer cette image comme image par défaut pour les événements « {cat} » ?",
    "agd.cover_default_yes": "Oui, enregistrer",
    "agd.cover_default_no": "Non, juste cet événement",
    "agd.cover_default_saved": "Image par défaut enregistrée pour « {cat} »",
    "param.catimg_remove": "Retirer",
    "param.catimg_removed": "Image par défaut retirée",
    "offline.banner": "Mode hors ligne — les données affichées peuvent dater de votre dernière connexion",
    "offline.make_available": "Rendre disponible hors ligne",
    "offline.available": "Disponible hors ligne",
    "offline.saved": "Fichier disponible hors ligne",
    "offline.removed": "Fichier retiré du mode hors ligne",
    "offline.error": "Téléchargement impossible",
    "offline.card_title": "Mode hors ligne",
    "offline.card_desc": "Fichiers téléchargés sur cet appareil (icône nuage sur chaque fichier) pour une consultation sans réseau.",
    "offline.files_count": "{n} fichier(s) hors ligne",
    "offline.usage": "{used} utilisés sur ~{quota}",
    "offline.clear": "Tout effacer",
    "offline.cleared": "Données hors ligne effacées",
    "param.change": "Changer",
    "param.subs_title": "Sous-catégories d'événements",
    "param.subs_desc": "Catégories principales figées ; les sous-catégories alimentent le formulaire de l'agenda. Les événements existants conservent leur étiquette si une sous-catégorie est supprimée.",
    "param.sub_new_placeholder": "Nouvelle sous-catégorie ({cat})",
    "param.axes_title": "Axes de travail (programmes)",
    "param.axes_desc": "Proposés en raccourcis dans l'éditeur de programme de l'agenda.",
    "param.axis_new_placeholder": "Nouvel axe (ex. Ensemble, Pipe…)",
    "param.instruments_title": "Instruments / Pratiques du groupe",
    "param.instrument_new_placeholder": "Nouvel instrument / pratique",
    "param.theme_title": "Personnalisation graphique",
    "param.theme_bg_app": "Fond général",
    "param.theme_bg_sidebar": "Navigation",
    "param.theme_bg_card": "Cartes",
    "param.theme_text_primary": "Texte principal",
    "param.theme_text_secondary": "Texte secondaire",
    "param.theme_brand_primary": "Couleur principale",
    "param.theme_brand_accent": "Couleur d'accent",
    "param.theme_border_color": "Bordures",
    "param.eyedropper": "Pipette",
    "param.theme_hint": "L'aperçu est appliqué en direct. Validez avec APPLIQUER pour l'enregistrer pour tout le groupe.",
    "param.sub_title": "Abonnement du groupe",
    "param.sub_trial_status": "Essai gratuit : {d} jours restants (fin le {date})",
    "param.plan_monthly": "mensuel",
    "param.plan_yearly": "annuel",
    "param.sub_active_status": "Abonnement {plan} actif jusqu'au {date}",
    "param.sub_pastdue_1": "Abonnement arrivé à échéance — période de grâce :",
    "param.sub_pastdue_2": "avant blocage de l'accès.",
    "param.grace_inner_s": "{d} jour restant",
    "param.grace_inner_p": "{d} jours restants",
    "param.sub_expired_status": "Abonnement expiré. Vos données sont conservées : réactivez pour retrouver l'accès complet.",
    "param.plan_monthly_name": "Mensuelle",
    "param.plan_yearly_name": "Annuelle",
    "param.per_month": "/mois",
    "param.per_year": "/an",
    "param.two_months_free": "2 mois offerts",
    "param.payment_secure": "Paiement sécurisé par Stripe (carte bancaire).",
    "param.payment_success": "Paiement confirmé — abonnement activé !",
    "param.payment_cancelled": "Paiement annulé.",
    "param.language_label": "Langue de l'interface",
    "param.language_hint": "Votre langue personnelle (par défaut : celle du groupe).",

    // Molette / formulaire morceau
    "wheel.validate": "Valider",
    "pfs.composer": "Compositeur",
    "pfs.duration": "Durée",
    "pfs.set_duration": "Régler la durée",
    "pfs.tempo": "Tempo (BPM)",
    "pfs.set_tempo": "Régler le tempo",
    "pfs.description": "Description",
    "pfs.history": "Historique",
    "pfs.category": "Catégorie",
    "pfs.tag_placeholder": "Ajouter un tag",
    "pfs.add_tag": "Ajouter le tag",
    "pfs.save_changes": "Enregistrer les modifications",
    "pfs.create_piece": "Créer le morceau",
    "pfs.initial_version": "Version initiale",
    "pfs.version_default": "Version",
    "pfs.pupitres_label": "Pupitres concernés",

    // Super-admin
    "sa.st_trial": "Essai",
    "sa.my_accounts": "Mes comptes",
    "sa.no_other_account": "Aucun autre compte connecté sur cet appareil.",
    "sa.kpi_groups": "Groupes",
    "sa.kpi_active": "Abos actifs",
    "sa.kpi_trial": "En essai",
    "sa.kpi_expired": "Expirés / suspendus",
    "sa.kpi_members": "Membres",
    "sa.kpi_mrr": "Revenu mensuel est.",
    "sa.kpi_active_7d": "Actifs 7 j",
    "sa.kpi_active_30d": "Actifs 30 j",
    "sa.search_group": "Rechercher un groupe (nom, @diminutif)…",
    "sa.export_csv": "Exporter (CSV)",
    "sa.activity_title": "Journal d'activité",
    "sa.activity_signups": "Dernières inscriptions",
    "sa.activity_payments": "Derniers paiements d'abonnement",
    "sa.activity_empty": "Aucune activité récente.",
    "sa.impersonate": "Voir en tant que (support)",
    "sa.impersonate_confirm": "Ouvrir ?",
    "sa.impersonate_q": "Ouvrir une session de support sur ce groupe ? L'action est journalisée.",
    "sa.delete_group_q": "Supprimer définitivement ce groupe et toutes ses données ? Cette action est irréversible.",
    "sa.delete_space_q": "Supprimer définitivement cet espace enseignement ? Cette action est irréversible.",
    "sa.users_activity_title": "Utilisateurs — dernière activité",
    "sa.users_activity_subtitle": "Date et heure de la dernière utilisation de l'application par chaque utilisateur (suivi en continu).",
    "sa.search_user": "Rechercher un utilisateur, un groupe…",
    "sa.col_member": "Membre",
    "sa.col_group": "Groupe",
    "sa.col_last_seen": "Dernière utilisation",
    "sa.never_seen": "Jamais",
    "sa.teaching_title": "Espaces Enseignement ({n})",
    "sa.teaching_subtitle": "Comptes éducateurs : consultation des espaces, de leurs membres et suppressions. Le contenu pédagogique n'est pas accessible ici.",
    "sa.col_space": "Espace",
    "sa.col_owner": "Enseignant",
    "sa.col_students": "Élèves",
    "sa.col_classes": "Classes",
    "sa.teaching_empty": "Aucun espace enseignement pour l'instant.",
    "sa.space_deleted": "Espace « {name} » supprimé définitivement",
    "sa.search_space": "Rechercher un espace (nom, enseignant, @diminutif)…",
    "sa.st_active": "Actif",
    "sa.st_past_due": "Impayé (grâce)",
    "sa.st_expired": "Expiré",
    "sa.st_suspended": "Suspendu",
    "sa.action_done": "Action appliquée",
    "sa.group_deleted": "Groupe « {name} » supprimé définitivement",
    "sa.delete_account": "Supprimer le compte",
    "sa.delete_account_q": "Supprimer définitivement ce compte, son espace personnel et toutes ses données ? Cette action est irréversible.",
    "sa.account_deleted": "Compte « {name} » supprimé définitivement",
    "sa.title": "Administration plateforme",
    "sa.groups_title": "Groupes ({n})",
    "sa.members_title": "Espaces personnels ({n})",
    "sa.members_subtitle": "Espaces personnels des membres : session support, suspension, suppression.",
    "sa.kpi_teaching": "Enseignants",
    "sa.col_firstname": "Prénom",
    "sa.col_lastname": "Nom",
    "sa.col_email": "E-mail",
    "sa.ensure_personal": "Créer / réparer les espaces",
    "sa.ensure_personal_done": "Espaces personnels : {n} au total, {r} doublon(s) retiré(s)",
    "sa.suspend_space": "Suspendre l'espace",
    "sa.unsuspend_space": "Réactiver l'espace",
    "sa.subtitle": "Gestion des suspensions et suppressions. Le contenu musical des groupes n'est pas accessible ici.",
    "sa.col_members": "Membres",
    "sa.col_created": "Créé le",
    "sa.extend7": "Prolonger l'essai de 7 jours",
    "sa.extend30": "Prolonger l'essai de 30 jours",
    "sa.activate_monthly": "Activer l'abonnement mensuel",
    "sa.activate_yearly": "Activer l'abonnement annuel",
    "sa.unsuspend": "Réactiver le groupe",
    "sa.suspend": "Suspendre le groupe",
    "sa.view_members": "Voir les membres",
    "sa.confirm_q": "Confirmer ?",
    "sa.monthly_caps": "Mensuel",
    "sa.yearly_caps": "Annuel",
    "sa.empty": "Aucun groupe pour l'instant.",

    // Inventaire
    "inv.loan_saved": "Prêt enregistré",
    "inv.just_added": "Justificatif joint",
    "inv.date_updated": "Date du prêt mise à jour",
    "inv.popup_blocked": "Autorisez les fenêtres pop-up pour imprimer",
    "inv.print_date": "Édité le",
    "inv.print_footnote": "✓ possédé · G prêté par le groupe · — non possédé",
    "inv.family_tenue": "Tenue",
    "inv.family_instrument": "Instrument",
    "inv.family_materiel": "Matériel",
    "inv.origin_personnel": "Personnel",
    "inv.origin_loaned": "Prêté par le groupe",
    "inv.owned": "Possédé",
    "inv.not_owned": "Non possédé",
    "inv.view_mine": "Ma vue",
    "inv.view_all": "Vue complète",
    "inv.tab_loans": "Prêts",
    "inv.new_item_placeholder": "Nouvel élément (ex. Cornemuse)",
    "inv.cat_obligatoire": "Obligatoire",
    "inv.cat_facultatif": "Facultatif",
    "inv.print": "Imprimer / PDF",
    "inv.item_col": "Élément",
    "inv.complete": "Complet",
    "inv.no_items": "Aucun élément d'inventaire.",
    "inv.no_items_admin": " Ajoutez le premier élément ci-dessus.",
    "inv.loans_title": "Matériel prêté par le groupe",
    "inv.new_loan": "Nouveau prêt",
    "inv.material": "Matériel",
    "inv.loan_date": "Date du prêt",
    "inv.justificatif": "Justificatif",
    "inv.status": "Statut",
    "inv.view": "Voir",
    "inv.attach": "Joindre",
    "inv.returned": "Retourné",
    "inv.ongoing": "En cours",
    "inv.no_loans": "Aucun prêt enregistré.",
    "inv.missing_title": "Éléments manquants",
    "inv.delete_item_title": "Supprimer l'élément ?",
    "inv.delete_item_desc": "« {name} » sera retiré définitivement de l'inventaire.",
    "inv.delete_loan_title": "Supprimer le prêt ?",
    "inv.delete_loan_desc": "Le prêt « {name} » sera supprimé définitivement.",
    "inv.other_free": "Autre (texte libre)",
    "inv.specify_material": "Précisez le matériel",
    "inv.recipient": "Membre bénéficiaire",
    "inv.save_loan": "Enregistrer le prêt",

    // Connexion (compléments)
    "login.group_created": "Groupe créé ! Votre ID : {id}",
    "login.migrate_title": "Liez votre adresse e-mail",
    "login.legacy_removed": "Cet identifiant appartenait à l'ancien système de connexion. Demandez une nouvelle invitation à votre groupe.",
    "auth.create_space": "+ Créer un nouvel espace",
    "layout.create_space": "Créer un espace",
    "layout.platform_section": "Plateforme",
    "layout.platform_console": "Console plateforme",
    "layout.platform_console_desc": "Administration RANNEA",
    "login.space_personal": "Compte personnel",
    "login.space_personal_desc": "Votre espace privé : bibliothèque, documents, favoris",
    "join.card_title": "Rejoindre un groupe",
    "join.card_desc": "Saisissez le nom exact du groupe. L'administrateur du groupe recevra votre demande et pourra l'accepter ou la refuser.",
    "join.name_placeholder": "Nom exact du groupe",
    "join.send": "Envoyer",
    "join.sent": "Demande envoyée au groupe",
    "join.my_requests": "Mes demandes",
    "join.status_pending": "En attente",
    "join.status_accepted": "Acceptée",
    "join.status_declined": "Refusée",
    "join.admin_title": "Demandes d'adhésion",
    "join.accept": "Accepter",
    "join.decline": "Refuser",
    "join.accepted_toast": "Demande acceptée — le membre a rejoint le groupe",
    "join.declined_toast": "Demande refusée",
    "space.create_title": "Créer un nouvel espace",
    "space.create_sub": "Groupe musical ou espace enseignant — il rejoindra votre sélecteur d'espaces.",
    "space.created": "Espace créé !",
    "space.personal_ready": "Votre espace personnel sera créé automatiquement : vous pourrez y ranger vos partitions, documents et favoris, et demander à rejoindre un groupe depuis les paramètres.",
    "login.migrate_intro": "RANNEA passe à la connexion par e-mail. Saisissez votre adresse : vous recevrez un code de vérification. Votre mot de passe actuel sera conservé, et si vous possédez déjà un compte RANNEA avec cette adresse, vos accès seront regroupés.",
    "login.migrate_email_label": "Votre adresse e-mail",
    "login.migrate_send": "Recevoir le code",
    "login.migrate_code_label": "Code reçu par e-mail (6 chiffres)",
    "login.migrate_submit": "Valider et migrer mon compte",
    "login.migrate_sent": "Code envoyé à {email}",
    "login.migrate_done": "Compte migré — bienvenue !",
    "login.migrate_cancel": "Retour",
    "login.migrate_resend": "Renvoyer le code",
    "login.account_activated": "Compte activé, bienvenue !",
    "auth.email_label": "Adresse e-mail",
    "auth.email_ph": "thomas.dupont@gmail.com",
    "auth.pwd_rule": "8 caractères minimum.",
    "auth.your_account": "Votre compte",
    "auth.your_group": "Votre groupe",
    "auth.create_account": "Créer mon compte",
    "auth.verify_title": "Vérifiez votre adresse e-mail",
    "auth.verify_sub": "Nous avons envoyé un code à :",
    "auth.code_label": "Chiffre du code",
    "auth.code_incomplete": "Saisissez les 6 chiffres du code.",
    "auth.confirm": "Confirmer",
    "auth.resend": "Renvoyer le code",
    "auth.resend_wait": "Renvoyer le code ({s} s)",
    "auth.code_resent": "Code renvoyé — vérifiez votre boîte mail.",
    "auth.email_verified": "Adresse e-mail vérifiée !",
    "auth.my_groups": "Mes groupes",
    "auth.choose_group_sub": "Choisissez l'espace à ouvrir :",
    "auth.no_group_title": "Aucun groupe pour le moment",
    "auth.no_group_sub": "Créez votre groupe ci-dessous, ou attendez une invitation d'un groupe existant.",
    "auth.forgot_title": "Réinitialiser mon mot de passe",
    "auth.forgot_sub": "Saisissez l'adresse e-mail de votre compte RANNEA.",
    "auth.send_link": "Envoyer le lien",
    "auth.forgot_sent": "Si un compte RANNEA correspond à cette adresse, vous recevrez un e-mail permettant de réinitialiser votre mot de passe.",
    "auth.back_to_login": "Retour à la connexion",
    "auth.reset_title": "Nouveau mot de passe",
    "auth.new_password": "Nouveau mot de passe",
    "auth.reset_save": "Enregistrer",
    "auth.reset_done": "Mot de passe modifié — vous pouvez vous connecter.",
    "auth.reset_ask_again": "Lien expiré ? Redemander un lien",
    "usr.send_invitation": "Envoyer l'invitation",
    "usr.invitation_sent_msg": "Invitation envoyée — le membre recevra un e-mail pour créer son compte ou rejoindre le groupe.",
    "usr.pending_invitations": "Invitations en attente",
    "usr.invitation_pending": "invitation en attente",
    "usr.resend_invitation": "Renvoyer",
    "usr.cancel_invitation": "Annuler",
    "usr.invitation_resent": "Invitation renvoyée",
    "usr.invitation_cancelled": "Invitation annulée",
    "inv.loading": "Chargement de l'invitation…",
    "inv.invalid": "Ce lien d'invitation est invalide.",
    "inv.expired": "Cette invitation a expiré. Demandez un nouveau lien à votre groupe.",
    "inv.cancelled": "Cette invitation a été annulée.",
    "inv.accepted": "Cette invitation a déjà été acceptée.",
    "inv.title": "Vous êtes invité·e !",
    "inv.for": "Invitation pour",
    "inv.invited_by": "Invité par {name}",
    "inv.join_button": "Rejoindre le groupe",
    "inv.logged_as": "Connecté en tant que {email}",
    "inv.existing_account": "Vous avez déjà un compte RANNEA — connectez-vous pour accepter l'invitation.",
    "inv.login_button": "Se connecter",
    "inv.create_account": "Créez votre compte pour rejoindre le groupe :",
    "inv.create_and_join": "Créer mon compte et rejoindre",
    "inv.welcome": "Bienvenue dans {name} !",
    "inv.wrong_logout": "Se déconnecter et changer de compte",
    "inv.back_login": "Aller à la connexion",
    "login.custom_style_placeholder": "Harmonie, Fanfare…",

    // Lecteur média
    "mp.ab_error": "Placez le point A avant le point B",
    "mp.marker_updated": "Repère modifié",
    "mp.marker_added": "Repère ajouté",
    "mp.label_renamed": "Étiquette renommée",
    "mp.label_deleted": "Étiquette supprimée",
    "mp.marker_edit": "Modifier le repère",
    "mp.marker_add_title": "Ajouter un repère",
    "mp.marker_dialog_sr": "Nommer et ajuster la position du repère",
    "mp.current_position": "Position actuelle",
    "mp.marker_placeholder": "Ex. 1ère phrase",
    "mp.labels": "Étiquettes",
    "mp.manage": "Gérer",
    "mp.manage_done": "Terminer",
    "mp.confirm_rename": "Valider le renommage",
    "mp.rename_named": "Renommer {name}",
    "mp.delete_named": "Supprimer {name}",
    "mp.player_sr": "Lecteur média",
    "mp.processing": "Conversion en cours — la lecture optimisée démarre automatiquement dès qu'elle est prête.",
    "mp.unsupported": "Ce format ({ext}) n'est pas lisible directement dans ce navigateur.",
    "mp.retry": "Réessayer",
    "mp.download": "Télécharger le fichier",
    "mp.clear_loop": "Effacer la boucle",
    "mp.exit_fullscreen": "Quitter le plein écran",
    "mp.speed": "Vitesse",
    "mp.now_playing": "Lecture en cours",
    "mp.markers": "Repères",
    "mp.audio_player": "Lecteur audio",
    "mp.parties": "Parties",
    "mp.loop": "Boucle",
    "mp.share": "Partager",
    "mp.expand": "Agrandir le lecteur",
    "mp.stop": "Arrêter la lecture",
    "mp.marker_add": "Ajouter un repère",
    "mp.no_markers": "Aucun repère pour l'instant.",

    // Tutoriel
    "tut.s1_title": "Bienvenue sur RANNEA",
    "tut.s1_desc": "Tout votre groupe musical au même endroit : partitions, audios, vidéos, agenda, présences et inventaire.",
    "tut.s2_title": "Bibliothèque",
    "tut.s2_desc": "Partitions PDF, audios et vidéos classés par catégorie, morceau, version et pupitre. Lecteur intégré avec vitesse, boucle A-B et repères.",
    "tut.s3_title": "Agenda & présences",
    "tut.s3_desc": "Répétitions et prestations à venir ; indiquez votre disponibilité en un clic, directement depuis le tableau de bord.",
    "tut.s4_title": "Setlists & favoris",
    "tut.s4_desc": "Constituez des programmes de prestation et retrouvez vos morceaux favoris en un instant.",
    "tut.s5_title": "Inventaire & prêts",
    "tut.s5_desc": "Déclarez votre matériel, suivez les tenues obligatoires et les prêts consentis par le groupe.",
    "tut.s6_title": "Espace administrateur",
    "tut.s6_desc": "Créez les comptes des membres, gérez instruments, sous-catégories, thème et abonnement depuis les Paramètres.",
    "tut.p1_title": "Bibliothèque",
    "tut.p1_desc": "Vos partitions PDF, audios et vidéos personnelles, classés par catégorie. Lecteur intégré avec vitesse, boucle A-B et repères.",
    "tut.p2_title": "Documents",
    "tut.p2_desc": "Centralisez vos documents personnels, organisés en dossiers, et téléchargez-les pour les consulter hors ligne.",
    "tut.p3_title": "Favoris",
    "tut.p3_desc": "Retrouvez en un instant vos morceaux et fichiers marqués d'un cœur.",
    "tut.p4_title": "Paramètres",
    "tut.p4_desc": "Gérez votre profil, votre affichage, le mode hors ligne — et demandez à rejoindre un groupe depuis l'onglet Groupe.",
    "tut.skip": "Passer l'intro",
    "tut.next": "Suivant",
    "tut.start": "C'est parti !",
    "tut.counter": "{i} / {n}",
    "param.tutorial_title": "Tutoriel de découverte",
    "param.tutorial_desc": "Revisitez la présentation des modules de l'application.",
    "param.tutorial_button": "Revoir le tutoriel",

    // Cotisations (module séparé de l'abonnement RANNEA)
    "fees.tab": "Cotisations",
    "fees.readonly_note": "Module informatif : aucun paiement ne se fait dans l'application pour le moment.",
    "fees.col": "Cotisation",
    "fees.summary_concerned": "membres concernés",
    "fees.summary_paid": "à jour",
    "fees.summary_due": "à payer",
    "fees.summary_exempt": "exonérés / non concernés",
    "fees.expected": "Total attendu",
    "fees.received": "Total reçu",
    "fees.remaining": "Reste",
    "fees.filter_all_status": "Tous les statuts",
    "fees.filter_all_instruments": "Tous les instruments",
    "fees.status_paid": "À jour",
    "fees.status_due": "À payer",
    "fees.status_pending": "Paiement en attente",
    "fees.status_exempt": "Exonéré",
    "fees.status_not_applicable": "Non concerné",
    "fees.mark_paid": "Marquer payé",
    "fees.mark_paid_title": "Enregistrer le paiement",
    "fees.paid_at": "Date du paiement",
    "fees.method": "Mode de paiement",
    "fees.method_especes": "Espèces",
    "fees.method_cheque": "Chèque",
    "fees.method_virement": "Virement",
    "fees.method_autre": "Autre",
    "fees.method_en_ligne": "Paiement en ligne",
    "fees.comment": "Commentaire (facultatif)",
    "fees.amount_paid": "Montant payé (€)",
    "fees.edit_title": "Cotisation du membre",
    "fees.status_label": "Statut",
    "fees.amount_due": "Montant demandé (€)",
    "fees.notes": "Commentaire administrateur",
    "fees.remind": "Rappeler les membres non à jour",
    "fees.remind_done": "Rappel envoyé à {n} membre(s)",
    "fees.remind_none": "Toutes les cotisations sont à jour",
    "fees.empty": "Aucune période de cotisation. Créez-la dans Paramètres > Cotisations.",
    "fees.paid_on": "Payé le {date}",
    "fees.updated": "Cotisation mise à jour",
    "feescfg.enable": "Activer le suivi des cotisations",
    "feescfg.rib_title": "RIB du groupe (visible par les membres)",
    "feescfg.rib_holder": "Titulaire du compte",
    "feescfg.rib_iban": "IBAN",
    "feescfg.rib_bic": "BIC",
    "feescfg.rib_save": "Enregistrer le RIB",
    "feescfg.alert": "Fenêtre de rappel à la connexion",
    "feescfg.alert_hint": "Affiche aux membres une fenêtre « cotisation à régler » à la connexion (1 fois par jour maximum).",
    "feescfg.periods_list": "Périodes existantes",
    "feescfg.edit_period": "Modifier la période",
    "feescfg.delete_period_q": "Supprimer cette période et toutes ses cotisations ? Cette action est irréversible.",
    "feescfg.period_updated": "Période mise à jour",
    "feescfg.period_deleted": "Période supprimée",
    "feescfg.amount_note": "Le nouveau montant s'applique aux cotisations encore « à payer » (les paiements déjà faits ou déclarés ne changent pas).",
    "fees.rib_title": "Paiement par virement",
    "fees.copy": "Copier",
    "fees.copied": "Copié dans le presse-papiers",
    "feescfg.enable_hint": "Si désactivé, les membres ne voient plus la carte cotisation ; l'administration conserve l'accès.",
    "feescfg.new_period": "Nouvelle période de cotisation",
    "feescfg.name": "Nom (ex. Cotisation annuelle 2026 / 2027)",
    "feescfg.amount": "Montant (€)",
    "feescfg.due_date": "Date limite de paiement",
    "feescfg.description": "Description (facultatif)",
    "feescfg.create": "Créer la période",
    "feescfg.created": "Période créée — cotisations générées pour tous les membres actifs",
    "feescfg.periods": "Périodes",
    "feescfg.current": "Courante",
    "feescfg.set_current": "Définir comme courante",
    "feescfg.config_saved": "Configuration enregistrée",
    "myfees.title": "Ma cotisation",
    "myfees.banner_title": "Cotisation à régler",
    "myfees.claim_paid": "J'ai payé par virement",
    "myfees.claim_done": "Merci ! L'administrateur validera à réception.",
    "myfees.later": "Plus tard",
    "fees.add_cotisation": "Ajouter une cotisation",
    "fees.add_title": "Nouvelle cotisation",
    "fees.member": "Membre",
    "fees.delete_title": "Supprimer la cotisation",
    "fees.delete_q": "Supprimer définitivement cette cotisation ? Cette action est irréversible.",
    "fees.deleted": "Cotisation supprimée",
    "fees.added": "Cotisation ajoutée",
    "fees.all_have_fee": "Tous les membres actifs ont déjà une cotisation sur cette période",
    "fees.instrument_of": "Pratique / instrument",
    "myfees.due_date": "À régler avant le {date}",
    "myfees.pay": "Payer ma cotisation",
    "myfees.paid_on": "Réglée le {date} ({method})",
    "myfees.history": "Historique",
    "myfees.none": "Aucune cotisation pour l'instant.",
    "myfees.payment_success": "Cotisation réglée — merci !",
    "myfees.payment_cancelled": "Paiement annulé.",
    "myfees.test_mode": "Paiement en ligne en mode test (Stripe).",
    "myfees.pending_hint": "Paiement déclaré — en attente de validation par l'administrateur.",
    "param.disciplines_label": "Disciplines pratiquées",
    "param.disciplines_hint": "Cochez les deux si le groupe pratique les deux disciplines : la bibliothèque affichera une zone « Bagad » et une zone « Pipe Band ».",
    "login.space_type_label": "Type d'espace",
    "login.space_band": "Groupe musical",
    "login.space_band_desc": "Pipe Band, Bagad, ensemble…",
    "login.space_school": "Enseigne­ment",
    "login.space_school_desc": "Espace professeurs & élèves",
    "login.space_dev": "En développement",
    "login.teacher_profile": "Votre profil professeur",
    "login.space_name": "Nom de l'espace d'enseignement",
    "teach.nav_students": "Mes élèves",
    "teach.nav_classes": "Mes classes",
    "teach.nav_my_classes": "Mes classes",
    "teach.students_title": "Mes élèves",
    "teach.classes_title": "Mes classes",
    "teach.add_student": "Ajouter un élève",
    "teach.add_student_desc": "L'identifiant généré (prenom@espace) sera à transmettre à l'élève pour sa première connexion.",
    "teach.student_created": "Élève créé — identifiant à transmettre : {login}",
    "teach.search_student": "Rechercher un élève…",
    "teach.no_students": "Aucun élève pour l'instant",
    "teach.no_classes": "Aucune classe pour l'instant",
    "teach.no_class_student": "Vous n'êtes rattaché à aucune classe pour le moment.",
    "teach.add_class": "Créer une classe",
    "teach.class_name": "Nom de la classe",
    "teach.description": "Description",
    "teach.level": "Niveau",
    "teach.notes": "Notes pédagogiques",
    "teach.members": "Membres",
    "teach.add_member": "Ajouter un élève",
    "teach.remove_member": "Retirer",
    "teach.delete_class": "Supprimer la classe",
    "teach.delete_class_desc": "La classe et ses inscriptions seront supprimées. Les comptes élèves, les relations individuelles et les autres classes sont conservés.",
    "teach.pending_account": "Compte à activer",
    "teach.account_active": "Compte actif",
    "teach.inactive_relation": "Relation inactive",
    "teach.deactivate_relation": "Désactiver la relation",
    "teach.reactivate_relation": "Réactiver la relation",
    "teach.my_space": "Mon espace",
    "teach.student_sheet": "Fiche élève",
    "teach.saved": "Enregistré",
    "teach.see_all": "Tout voir",
    "teach.member_count_s": "{n} élève",
    "teach.member_count_p": "{n} élèves",
    "teach.nav_agenda": "Agenda",
    "teach.nav_lessons": "Mes cours",
    "teach.add_lesson": "Créer un cours",
    "teach.edit_lesson": "Modifier le cours",
    "teach.lesson_type": "Type de cours",
    "teach.lesson_individual": "Cours individuel",
    "teach.lesson_class": "Cours de classe",
    "teach.lesson_student": "Élève",
    "teach.lesson_class_label": "Classe",
    "teach.lesson_date": "Date",
    "teach.lesson_time": "Heure",
    "teach.lesson_duration": "Durée (min)",
    "teach.lesson_notes": "Notes de cours",
    "teach.next_lesson": "Prochain cours",
    "teach.no_lessons": "Aucun cours prévu",
    "teach.upcoming_lessons": "Cours à venir",
    "teach.past_lessons": "Cours passés",
    "teach.minutes": "{n} min",
    "teach.delete_lesson": "Supprimer le cours",
    "teach.delete_lesson_desc": "Ce cours sera définitivement supprimé.",
    "teach.lesson_created": "Cours créé",
    "teach.lessons_history": "Historique des cours",
    "teach.class_lessons": "Cours de la classe",
    "teach.nav_resources": "Ressources",
    "teach.my_resources": "Mes ressources",
    "teach.resources_title": "Ressources pédagogiques",
    "teach.add_resource": "Ajouter une ressource",
    "teach.resource_title": "Titre",
    "teach.resource_file": "Fichier",
    "teach.resource_or_link": "ou un lien externe",
    "teach.resource_url": "Lien (URL)",
    "teach.resource_shared": "Partagée",
    "teach.resource_not_shared": "Non partagée",
    "teach.share": "Partager",
    "teach.share_title": "Partager « {name} »",
    "teach.share_students": "Élèves",
    "teach.share_classes": "Classes",
    "teach.no_resources": "Aucune ressource pour l'instant",
    "teach.no_resources_student": "Aucune ressource partagée avec vous pour le moment.",
    "teach.download": "Télécharger",
    "teach.open_link": "Ouvrir le lien",
    "teach.delete_resource": "Supprimer la ressource",
    "teach.delete_resource_desc": "La ressource et tous ses partages seront supprimés. Les élèves et les classes sont conservés.",
    "teach.type_pdf": "PDF",
    "teach.type_score": "Partition",
    "teach.type_image": "Image",
    "teach.type_audio": "Audio",
    "teach.type_video": "Vidéo",
    "teach.type_document": "Document",
    "teach.type_link": "Lien",
    "mp.play": "Lire",
    "teach.recent_resources": "Ressources récentes",
    "teach.shared_resources": "Ressources partagées",
    "teach.class_resources": "Ressources de la classe",
    "teach.quick_share": "Partager une ressource",
    "teach.uploading": "Envoi en cours…",
    "teach.nav_assignments": "Travail à faire",
    "teach.assignments_title": "Travail à faire",
    "teach.add_assignment": "Créer un travail",
    "teach.edit_assignment": "Modifier le travail",
    "teach.assignment_target": "Destinataire",
    "teach.due_date": "Échéance",
    "teach.no_due": "Sans échéance",
    "teach.linked_resources": "Ressources liées",
    "teach.mark_done": "Marquer terminé",
    "teach.mark_todo": "Remettre à faire",
    "teach.done_badge": "Terminé",
    "teach.todo_badge": "À faire",
    "teach.overdue": "En retard",
    "teach.done_count": "{done}/{total} terminé(s)",
    "teach.no_assignments": "Aucun travail pour l'instant",
    "teach.no_assignments_student": "Aucun travail à faire. Bravo !",
    "teach.delete_assignment": "Supprimer le travail",
    "teach.delete_assignment_desc": "Ce travail sera supprimé. Les ressources liées restent dans votre bibliothèque.",
    "teach.assignment_created": "Travail créé",
    "teach.assignment_dialog_desc": "Créez un devoir pour un élève ou une classe, avec échéance et ressources facultatives.",
    "teach.to_follow": "Travail à suivre",
    "teach.done_section": "Terminé",
    "teach.todo_section": "À faire",
    "teach.for_student": "Individuel",
    "teach.for_class": "Classe",
  },
  en: {
    tagline: "The link between musicians",
    hero_title_1: "Your music group's",
    hero_title_2: "home base",
    hero_sub: "Sheet music library, audio and video, calendar, attendance, setlists, inventory: your whole Pipe Band or Bagad in one place.",
    trial_line: "3-month free trial for every new group.",
    tab_login: "Sign in",
    tab_register: "New account",
    tab_activate: "First sign-in",
    id_label: "ID",
    id_placeholder: "firstname@groupshort",
    password_label: "Password",
    remember_me: "Stay signed in",
    forgot_password: "Forgot password?",
    forgot_info: "Contact an administrator of your group: they will reset your access. You can then use “First sign-in”.",
    connect: "SIGN IN",
    connecting: "Signing in…",
    group_creation: "Group creation",
    group_creation_personal: "Personal space creation",
    group_creation_school: "Teaching space creation",
    group_name: "Group name",
    diminutif: "Short name",
    style_label: "Style",
    custom_style: "Custom style",
    logo_optional: "Logo (optional)",
    language: "Language",
    next: "NEXT",
    back: "Back",
    admin_profile: "Your administrator profile",
    firstname: "First name",
    lastname: "Last name",
    instrument_label: "Instrument / Practice",
    create_group: "CREATE GROUP",
    creating: "Creating…",
    first_connection: "First sign-in",
    admin_id_label: "ID created by the administrator",
    create_password: "Create your password",
    confirmation: "Confirmation",
    activate: "ACTIVATE",
    activating: "Activating…",
    your_id_will_be: "Your ID will be:",

    // Common
    "common.save": "Save",
    "common.saving": "Saving…",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.rename": "Rename",
    "common.add": "Add",
    "common.close": "Close",
    "nav.help": "Help",
    "common.uploading": "Uploading",
    "help.title": "Help center",
    "help.subtitle": "Detailed guides to make the most of every RANNEA feature.",
    "help.replay": "Replay tutorial",
    "help.replay_hint": "Replay the start guided tour anytime.",
    "help.guided_tour": "Interactive tour",
    "tour.done": "Done",
    "common.confirm": "Confirm",
    "common.back": "Back",
    "common.search": "Search",
    "common.loading": "Loading…",
    "common.yes": "Yes",
    "common.no": "No",
    "common.maybe": "Maybe",
    "common.logout": "Sign out",
    "common.group_logo": "Group logo",
    "common.optional": "optional",
    "common.availability_saved": "Availability saved",

    // Navigation
    "nav.dashboard": "Dashboard",
    "nav.library": "Library",
    "nav.documents": "Documents",
    "nav.agenda": "Calendar",
    "nav.presence": "Attendance",
    "nav.inventory": "Inventory",
    "nav.favorites": "Favorites",
    "nav.setlists": "Setlists",
    "nav.purchases": "Shop",
    "achats.dev_title": "Under development",
    "achats.dev_text": "This module will be available soon. Thank you for your patience!",
    "param.catimg_desc": "Shown as thumbnails in the agenda and as the background of the dashboard “Next event” card.",
    "agd.cover_default_title": "Default image?",
    "agd.cover_default_q": "Save this image as the default image for “{cat}” events?",
    "agd.cover_default_yes": "Yes, save it",
    "agd.cover_default_no": "No, just this event",
    "agd.cover_default_saved": "Default image saved for “{cat}”",
    "param.catimg_remove": "Remove",
    "param.catimg_removed": "Default image removed",
    "offline.banner": "Offline mode — displayed data may be from your last connection",
    "offline.make_available": "Make available offline",
    "offline.available": "Available offline",
    "offline.saved": "File available offline",
    "offline.removed": "File removed from offline mode",
    "offline.error": "Download failed",
    "offline.card_title": "Offline mode",
    "offline.card_desc": "Files downloaded on this device (cloud icon on each file) for access without network.",
    "offline.files_count": "{n} offline file(s)",
    "offline.usage": "{used} used of ~{quota}",
    "offline.clear": "Clear all",
    "offline.cleared": "Offline data cleared",
    "shop.title": "Shop",
    "shop.subtitle": "Drinks, uniforms, merch, fees…",
    "shop.catalog": "Catalog",
    "shop.manage": "Purchases & Payments — management",
    "shop.manage_short": "Manage",
    "shop.back_catalog": "All categories",
    "shop.empty_catalog": "No categories yet.",
    "shop.empty_items": "No items in this category.",
    "shop.items_count": "{count} item(s)",
    "shop.cat_new": "New category",
    "shop.cat_edit": "Edit category",
    "shop.cat_name": "Category name",
    "shop.icon": "Icon",
    "shop.allow_tab": "Allow tab",
    "shop.allow_immediate": "Allow immediate payment",
    "shop.inactive_badge": "Disabled",
    "shop.item_new": "New item",
    "shop.item_edit": "Edit item",
    "shop.item_name": "Item name",
    "shop.item_desc": "Description (optional)",
    "shop.price": "Price (€)",
    "shop.item_active": "Item active",
    "shop.item_tab_mode": "Tab for this item",
    "shop.tab_inherit": "Same as category",
    "shop.yes": "Yes",
    "shop.no": "No",
    "shop.image": "Image (optional)",
    "shop.tab_badge": "Tab",
    "shop.pay_badge": "Payment",
    "shop.cat_created": "Category created",
    "shop.cat_updated": "Category updated",
    "shop.item_created": "Item created",
    "shop.item_updated": "Item updated",
    "shop.delete_cat_desc": "Delete category “{name}” and its items? (Not possible if it has history — disable it instead.)",
    "shop.delete_item_desc": "Delete item “{name}”? (Not possible if it has history — disable it instead.)",
    "shop.tab_title": "My tab",
    "shop.finance_view": "Payments",
    "shop.open_tabs": "Open tabs",
    "shop.balance_due": "Balance due",
    "shop.balance_none": "Nothing to pay",
    "shop.cart_validate": "Put on my tab",
    "shop.cart_added": "Added to your tab",
    "shop.tab_empty": "No purchases yet.",
    "shop.tab_open": "To pay",
    "shop.tab_settled": "Settled",
    "shop.tab_cancelled": "Cancelled",
    "shop.all_status": "All",
    "shop.no_open_tabs": "Nothing to display.",
    "shop.settle": "Settle",
    "shop.settle_method": "Payment method",
    "shop.settle_amount": "Amount paid (€)",
    "shop.settle_note": "Note (optional)",
    "shop.method_cash": "Cash",
    "shop.method_check": "Check",
    "shop.method_transfer": "Transfer",
    "shop.settle_done": "Payment recorded",
    "shop.cancel_purchase": "Cancel",
    "shop.cancel_reason": "Cancellation reason",
    "shop.cancel_done": "Purchase cancelled",
    "shop.cancel_hint": "Cancellation is tracked (reason, author, date). The purchase is never deleted.",
    "shop.remaining": "Remaining",
    "shop.settlements": "Payments",
    "shop.cancelled_by": "Cancelled by {name}",
    "shop.qr_code": "QR code",
    "shop.qr_title": "QR code — {name}",
    "shop.qr_hint": "Display near the till: the member scans the code, logs in if needed, and lands directly on this category.",
    "shop.qr_copy": "Copy link",
    "shop.qr_download": "Download (PNG)",
    "shop.qr_invalid": "This link does not match any active category of your group.",
    "shop.pots_title": "Money pots",
    "shop.pot_contribute": "Contribute",
    "shop.pot_collected": "{amount} collected",
    "shop.pot_goal_label": "Goal: {amount}",
    "shop.pot_goal_reached": "Goal reached!",
    "shop.pot_free": "Free contribution",
    "shop.pot_amount": "Your contribution amount (€)",
    "shop.pot_tab_hint": "The amount is added to your tab; you pay the treasurer like at the bar.",
    "shop.pot_contributed": "Contribution added to your tab",
    "shop.pot_new": "New money pot",
    "shop.pot_edit": "Edit money pot",
    "shop.pot_name": "Money pot name",
    "shop.pot_desc": "Description (optional)",
    "shop.pot_goal": "Goal (€, optional)",
    "shop.pot_closed": "Closed",
    "shop.pot_created": "Money pot created",
    "shop.pot_updated": "Money pot updated",
    "shop.pot_empty": "No money pot yet.",
    "shop.delete_pot_desc": "Delete money pot “{name}”? (Not possible if contributions exist — close it instead.)",
    "shop.my_fee": "My membership fee",
    "shop.fees_summary": "Membership fees",
    "shop.fees_goto": "Manage fees",
    "shop.treasury": "Treasury",
    "shop.period_month": "This month",
    "shop.period_season": "Current season",
    "shop.period_all": "All time",
    "shop.date_from": "From",
    "shop.date_to": "to",
    "shop.received_period": "Received over period",
    "shop.open_tabs_total": "Open tabs",
    "shop.refunds_due": "Refunds due",
    "shop.sales_count": "{count} purchase(s) • {amount} sold over period",
    "shop.by_method": "By payment method",
    "shop.debtors": "Open balances by member",
    "shop.refund_to": "Refund to {name}",
    "shop.no_refunds": "No pending refunds.",
    "shop.mark_refunded": "Mark as refunded",
    "shop.refunded_done": "Refund marked as done",
    "shop.export_csv": "Export payments (CSV)",
    "shop.filter_member": "All members",
    "shop.online_payments": "Online payments",
    "shop.test_mode_badge": "TEST MODE",
    "shop.pay_connect": "Enable online payments",
    "shop.pay_resume": "Resume Stripe onboarding",
    "shop.pay_active": "Active — Stripe account connected",
    "shop.pay_test_shared": "Active — shared test account (sandbox)",
    "shop.pay_pending": "Stripe onboarding to complete",
    "shop.pay_none": "Not configured",
    "shop.pay_hint": "Test mode: card 4242 4242 4242 4242, any future date, any CVC. Money lands on the group's Stripe account (Stripe Connect).",
    "shop.pay_tab": "Pay online (test)",
    "shop.pay_online": "Pay online (test)",
    "shop.buy_now": "Buy now",
    "shop.pay_success": "Online payment confirmed (test mode)",
    "shop.pay_cancelled": "Payment cancelled — nothing was charged.",
    "shop.connect_returned": "Back from Stripe — payment status updated.",
    "shop.live_mode_badge": "LIVE",
    "shop.pay_hint_live": "Live payments active — money lands on the group's Stripe account (Stripe Connect).",
    "shop.pay_tab_live": "Pay online",
    "shop.pay_online_live": "Pay online",
    "shop.pay_success_live": "Online payment confirmed",
    "shop.prod_title": "Go-live checklist",
    "shop.prod_intro": "Payments are in test mode (no real money). To accept real payments:",
    "shop.prod_step1": "Claim the Emergent sandbox (or create your Stripe account) and complete identity verification.",
    "shop.prod_step2": "Enable Stripe Connect in the Dashboard (Settings → Connect).",
    "shop.prod_step3": "Add your live keys (pk_live / sk_live) and the live webhook secret to the environment variables, then STRIPE_MODE=live.",
    "shop.prod_step4": "Register the live webhook endpoint (/api/stripe/webhook) and validate with a real 1 € payment.",
    "shop.prod_guide": "Full step-by-step guide: docs/PRODUCTION_STRIPE.md",
    "shop.method_online": "Online",
    "shop.refunds_show_all": "Show all ({count})",
    "shop.refunds_show_less": "Show less",
    "shop.total": "Total",
    "shop.onsite": "On-site payment",
    "shop.onsite_hint": "Compose the bill: the member will pay by scanning the QR with their phone (card, Apple Pay, Google Pay).",
    "shop.onsite_show_qr": "Show payment QR",
    "shop.onsite_scan": "The member scans this code with their phone and pays online.",
    "shop.onsite_waiting": "Waiting for payment…",
    "shop.onsite_paid": "Payment received!",
    "shop.onsite_abandon": "Abandon sale",
    "shop.onsite_abandon_reason": "Counter sale abandoned",
    "shop.onsite_new": "New sale",
    "shop.onsite_close": "Close",
    "pay.thanks_title": "Payment confirmed",
    "pay.thanks_body": "Thank you! You can close this page.",
    "pay.cancelled_title": "Payment cancelled",
    "pay.cancelled_body": "Nothing was charged. You can close this page.",
    "nav.users": "Members",
    "nav.settings": "Settings",
    "nav.home": "Home",

    // Event categories
    "cat.repetition": "Rehearsal",
    "cat.prestation": "Performance",
    "cat.autre": "Other",

    // Layout / frame
    "layout.greeting": "Hello {name}",
    "layout.my_groups": "My groups",
    "layout.my_space": "My space",
    "layout.other_accounts": "Other accounts on this device",
    "layout.current_group": "Active group",
    "layout.add_group": "Add a group",
    "layout.add_group_identity": "This RANNEA account signs in with its email from the login page. Once signed in, switch via “My groups”.",
    "layout.add_group_title": "Connect another group",
    "layout.add_group_desc": "Enter your account ID from the other group (e.g. firstname@othergroup). Switching happens without signing out.",
    "layout.notifications": "Notifications",
    "layout.mark_all_read": "Mark all as read",
    "layout.no_notifications": "No notifications",
    "layout.reminder_title": "Next event: are you available?",
    "layout.badge_trial_s": "Free trial: {d} day left",
    "layout.badge_trial_p": "Free trial: {d} days left",
    "layout.badge_pastdue_s": "Renew: {d} day before suspension",
    "layout.badge_pastdue_p": "Renew: {d} days before suspension",
    "layout.sub_active": "Active subscription",
    "layout.sub_expired": "Subscription expired",
    "layout.trial_prefix": "Free trial",
    "layout.trial_inner_s": "{d} day left",
    "layout.trial_inner_p": "{d} days left",
    "layout.trial_cta": "Choose a plan",
    "layout.pastdue_prefix": "Subscription to renew",
    "layout.pastdue_inner_s": "suspension in {d} day",
    "layout.pastdue_inner_p": "suspension in {d} days",
    "layout.renew": "Renew",
    "layout.suspended_title": "Group suspended",
    "layout.expired_title": "Subscription expired",
    "layout.suspended_text": "The group's access is suspended by the platform. Contact support for more information.",
    "layout.expired_text_1": "The group's access is suspended.",
    "layout.expired_text_data": "Your data is kept",
    "layout.expired_text_2": "— reactivate the subscription to regain full access.",
    "layout.reactivate": "Reactivate subscription",
    "layout.contact_admin": "Contact your group's administrator to restore access.",
    "layout.more_tabs": "More tabs",

    // Dashboard
    "dash.stat_members": "Active members",
    "dash.stat_pieces": "Pieces",
    "dash.stat_documents": "Documents",
    "dash.stat_upcoming": "Upcoming events",
    "dash.next_event": "Next event",
    "dash.members_available": "member(s) available",
    "dash.my_availability": "My availability",
    "dash.program": "Program",
    "dash.no_upcoming": "No upcoming events.",
    "dash.upcoming_title": "Coming up — next 5 events",
    "dash.recent_title": "Recent activity",
    "dash.no_recent": "No recently opened files.",

    // Availability
    "avail.yes": "Yes",
    "avail.maybe": "Maybe",
    "avail.no": "No",
    "avail.none": "No answer",

    // Confirmation
    "confirm.title": "Confirm deletion",
    "confirm.cancel": "Cancel",
    "confirm.delete": "Delete",

    // Favorites
    "fav.title": "My favorites",
    "fav.subtitle": "Your favorites are strictly personal.",
    "fav.empty": "No favorites. Add pieces, media or documents with the heart icon.",
    "fav.type_piece": "Pieces",
    "fav.type_version": "Versions",
    "fav.type_file": "Media & files",
    "fav.type_document": "Documents",

    // Attendance
    "pres.title": "Attendance",
    "pres.subtitle": "Click your own cells to change your availability.",
    "pres.full_view": "Full matrix",
    "pres.present_label": "present",
    "pres.tab_upcoming": "Upcoming",
    "pres.tab_done": "Completed",
    "pres.loading": "Loading attendance…",
    "pres.zoom_out": "Zoom out",
    "pres.zoom_in": "Zoom in",
    "pres.member": "Member",
    "pres.you": "(you)",
    "pres.no_instrument": "No instrument",
    "pres.empty_upcoming": "No upcoming events.",
    "pres.empty_past": "No past events.",

    // Setlists
    "setl.empty": "No setlists.",
    "setl.new_placeholder": "New setlist",
    "setl.select_prompt": "Select a setlist.",
    "setl.no_pieces": "No pieces in this setlist.",
    "setl.piece_deleted": "Deleted piece",
    "setl.add_piece_placeholder": "Add a piece from the Library…",
    "setl.delete_title": "Delete the setlist?",
    "setl.delete_desc": "“{name}” will be permanently deleted.",

    // Members
    "usr.role_admin": "Administrator",
    "usr.role_music_leader": "Music leader",
    "usr.role_treasurer": "Treasurer",
    "usr.role_musician": "Musician",
    "usr.role_member": "Non-musician member",
    "usr.role_prof": "Teacher",
    "usr.role_student": "Student",
    "usr.role_updated": "Role updated",
    "usr.instrument_updated": "Instrument updated",
    "usr.deactivated": "Account deactivated (data kept)",
    "usr.reactivated": "Account reactivated",
    "usr.reset_done": "Access reset: {name} will need to use “First sign-in” to create a new password.",
    "usr.title": "Members",
    "usr.new": "NEW MEMBER",
    "usr.search_placeholder": "Search a member…",
    "usr.show_inactive": "Show deactivated accounts",
    "usr.col_name": "Name",
    "usr.col_role": "Role",
    "usr.col_instrument": "Instrument/Practice",
    "usr.col_actions": "Actions",
    "usr.you": "(you)",
    "usr.pending": "(pending activation)",
    "usr.disabled": "(deactivated)",
    "usr.none_found": "No members found.",
    "usr.create_title": "New member",
    "usr.create_desc": "The member will receive a secure invitation email to join the group.",
    "usr.created_msg": "Account created. Share this ID with the member:",
    "usr.group_label": "Group: {name}",
    "usr.create_submit": "Create member",
    "usr.choose": "Choose…",
    "usr.reset_title": "Reset password (the member will use “First sign-in” again)",
    "usr.deactivate_title": "Deactivate (keeps data)",
    "usr.reactivate_title": "Reactivate",
    "usr.delete_title_attr": "Delete permanently",
    "usr.delete_title": "Permanent deletion",
    "usr.delete_desc": "The account of {name} will be permanently removed from the database. There is no trash. To keep their data, use deactivation instead.",

    // Calendar
    "agd.updated": "Event updated",
    "agd.created": "Event created",
    "agd.created_recurrent": "Recurring events created",
    "agd.program_saved": "Program saved",
    "agd.piece_fallback": "Piece",
    "agd.new_event": "New event",
    "agd.remind_avail": "Remind availability",
    "agd.remind_avail_done": "{n} member(s) reminded",
    "agd.remind_avail_none": "Everyone has already answered",
    "agd.presence_shortcut": "Attendance table",
    "agd.edit_event": "Edit event",
    "agd.loading": "Loading calendar…",
    "agd.past_events": "Past events",
    "agd.filter_all": "All",
    "agd.type_label": "Event type",
    "agd.date": "Date",
    "agd.start": "Start",
    "agd.end": "End",
    "agd.location": "Location",
    "agd.location_search_placeholder": "Name, address, city, postcode…",
    "agd.location_no_result": "No result — manual entry is kept.",
    "agd.location_clear_geo": "Remove geolocation (keep the text)",
    "agd.itinerary": "Directions",
    "agd.share": "Share",
    "agd.add_calendar": "Add to calendar",
    "agd.ics_downloaded": "Calendar file downloaded — open it to add the event",
    "agd.share_text": "{title} — {date}",
    "agd.link_copied": "Event link copied!",
    "agd.copy_link": "Copy link",
    "install.title": "Install the RANNEA app",
    "install.subtitle": "Open RANNEA in one click, like a real app.",
    "install.question": "Which device are you using?",
    "install.detected": "Detected",
    "install.later": "Later",
    "install.now": "Install now",
    "install.direct_hint": "Direct install on this device, no manual steps.",
    "install.guide_title": "Or follow the guide:",
    "install.done_hint": "Once installed, RANNEA opens straight to your space if you stay signed in.",
    "install.device.pc": "PC (Windows)",
    "install.device.mac": "Mac",
    "install.device.ios": "iPhone / iPad",
    "install.device.android": "Android",
    "install.guide.pc": "1. Click the install icon (small screen with arrow) at the right of the address bar.\n2. Or: ⋮ menu at top right → “Save and share” → “Install RANNEA”.\n3. Confirm: the RANNEA icon appears in your apps.",
    "install.guide.mac": "With Safari (macOS Sonoma or later):\n1. Open the File menu → “Add to Dock”.\n2. Confirm: RANNEA appears in your Dock.\nWith Chrome: click the install icon at the right of the address bar, then “Install”.",
    "install.guide.ios_share": "On iPhone/iPad, installation must be done from Safari.",
    "install.guide.ios": "1. Open this address in Safari.\n2. Tap the Share button (square with an upward arrow).\n3. Scroll and tap “Add to Home Screen”.\n4. Tap “Add”: the RANNEA icon joins your home screen.",
    "install.guide.android": "1. Tap “Install” if the banner appears, otherwise: ⋮ menu at top right.\n2. Choose “Add to Home screen” or “Install app”.\n3. Confirm: the RANNEA icon joins your home screen.",
    "agd.open_navigation": "Open in navigation app",
    "agd.nav_choose": "Open directions with…",
    "agd.nav_apple": "Apple Maps",
    "agd.nav_web": "View on web map (OpenStreetMap)",
    "agd.this_week": "This week",
    "agd.next_week": "Next week",
    "agd.filter_unanswered": "Unanswered",
    "agd.unanswered_state": "Response needed",
    "agd.all_answered": "No events awaiting your response.",
    "agd.organized_by": "Organized by {name}",
    "agd.participate": "Attend",
    "agd.decline": "Decline",
    "agd.responses_title": "Responses",
    "agd.resp_yes_label": "attending",
    "agd.resp_pending_label": "awaiting response",
    "agd.resp_no_label": "declined",
    "agd.see_presences": "View attendance",
    "agd.event_not_found": "Event not found.",
    "agd.description_label": "Description",
    "agd.edit_program": "Edit program",
    "agd.delete_event": "Delete event",
    "agd.delete_event_desc": "“{name}” and its associated responses will be permanently deleted.",
    "agd.deleted": "Event deleted",
    "common.error": "Something went wrong",
    "agd.cover_label": "Photo / Poster",
    "agd.end_date": "End date (optional)",
    "agd.date_range": "From {start} to {end}",
    "agd.cover_add": "Add an image",
    "agd.cover_remove": "Remove image",
    "agd.title_label": "Title (optional)",
    "agd.title_placeholder": "E.g. Spring concert",
    "agd.weather_later": "Weather available closer to the event",
    "wx.clear": "Clear sky",
    "wx.partly": "Partly cloudy",
    "wx.cloudy": "Cloudy",
    "wx.fog": "Fog",
    "wx.drizzle": "Drizzle",
    "wx.rain": "Rain",
    "wx.showers": "Showers",
    "wx.snow": "Snow",
    "wx.storm": "Thunderstorm",
    "agd.comments_title": "Comments",
    "agd.no_comments": "No comments yet.",
    "agd.comment_placeholder": "Write a comment…",
    "agd.comment_send": "Send",
    "agd.comment_reply": "Reply",
    "agd.comment_reply_to": "Replying to {name}",
    "agd.comment_delete_desc": "Permanently delete this comment?",
    "agd.time_now": "Just now",
    "agd.time_min": "{count} min ago",
    "agd.time_hours": "{count} h ago",
    "agd.time_days": "{count} d ago",
    "agd.notes_optional": "Notes (optional)",
    "agd.dress_label": "Outfit worn on the day",
    "agd.dress_placeholder": "E.g. full dress, kilt + vest…",
    "agd.dress_items_label": "Outfit items (inventory)",
    "agd.dress_prefix": "Outfit:",
    "agd.dress_items_prefix": "Outfit items:",
    "agd.recurrent": "Recurring event",
    "agd.recurrence_label": "Repeat",
    "agd.freq_daily": "Daily",
    "agd.freq_weekly": "Weekly",
    "agd.freq_monthly": "Monthly",
    "agd.until": "Until",
    "agd.setlist_label": "Setlist / musical program",
    "agd.program_custom_label": "Custom program — sections & pieces",
    "agd.no_setlist": "None",
    "agd.checklist_label": "Equipment checklist",
    "agd.create_event": "Create event",
    "agd.create_recurrent": "Create events",
    "agd.delete_title": "Delete the event?",
    "agd.delete_desc": "“{name}” will be permanently deleted. There is no trash.",
    "agd.note_optional": "Note (optional)",
    "agd.axis_label": "Work axis",
    "agd.axis_placeholder": "Ensemble, Pipe…",
    "agd.piece_picker_label": "Piece — category → pieces, quick search",
    "agd.piece_search": "Search a piece…",
    "agd.no_category": "No category",
    "agd.no_piece": "No pieces",
    "agd.save_program": "Save program",
    "agd.program_create": "Create a rehearsal program",
    "agd.program_linked": "Program linked to the rehearsal",
    "agd.program_new": "New program",
    "agd.program_name_ph": "Weekly rehearsal",
    "agd.mode_concert": "Concert mode",
    "agd.mode_repetition": "Rehearsal mode",
    "agd.pick": "Pick",
    "agd.block": "Block",
    "agd.block_empty": "No pieces in this block.",
    "agd.add_block": "Add a block",
    "agd.block_rename_ph": "Block name",
    "agd.choose_piece": "Choose a piece",
    "agd.piece_search_ph": "Search by name, composer, tag…",
    "agd.all_styles": "All styles",
    "agd.program_summary": "{n} pieces · {mode}",
    "agd.piece_added": "Piece added to the program",
    "agd.program_reset": "Recreate the program",
    "agd.switch_mode": "Switch mode",
    "nset.title": "Notifications",
    "nset.desc": "Stay informed about your group's updates: pieces, documents and events.",
    "nset.question": "Would you like to enable notifications?",
    "nset.yes": "Yes, enable",
    "nset.no": "No thanks",
    "nset.later_hint": "You can change this choice anytime in Settings.",
    "nset.types_title": "What would you like to receive?",
    "nset.types_desc": "Choose which notification types to receive.",
    "nset.saved": "Notification preferences saved",

    // Documents
    "docs.folder_created": "Folder created",
    "docs.renamed": "Renamed",
    "docs.deleted": "Permanently deleted",
    "docs.file_renamed": "File renamed",
    "docs.import_done": "Import complete",
    "docs.link_added": "Link added",
    "docs.search_placeholder": "Search…",
    "docs.no_results": "No results",
    "docs.folders_section": "Folders",
    "docs.files_section": "Files",
    "docs.view_grid": "Grid view",
    "docs.view_list": "List view",
    "docs.tree_show": "Show folder tree",
    "docs.tree_hide": "Hide folder tree",
    "docs.loading": "Loading documents…",
    "docs.no_folder": "No folders.",
    "docs.no_folder_create": " Create your first folder.",
    "docs.new_folder": "New folder",
    "docs.new_subfolder": "New subfolder",
    "docs.select_folder": "Select a folder.",
    "docs.subfolder": "Subfolder",
    "docs.add_files": "Add files",
    "docs.add_link": "Add a link",
    "docs.no_file": "No files in this folder.",
    "docs.no_file_hint": " Add or drag & drop your files here.",
    "docs.download": "Download",
    "docs.create_folder_sr": "Create a folder or subfolder",
    "docs.rename_folder_sr": "Rename the selected folder",
    "docs.delete_folder_desc": "This folder and all its content will be permanently deleted. There is no trash.",
    "docs.add_link_sr": "Add an external link to the folder",
    "docs.link_name": "Link name",
    "docs.upload_names_title": "Name the files before adding",
    "docs.upload_names_sr": "Rename files before import",
    "docs.import": "Import",
    "docs.file_counter": "File {i}/{total}",
    "docs.rename_file_title": "Rename file",
    "docs.fullscreen": "Fullscreen",
    "docs.pdf_reader_sr": "PDF document viewer",
    "common.create": "Create",

    // Library
    "lib.cat_created": "Category created",
    "lib.piece_updated": "Piece updated",
    "lib.piece_created": "Piece created",
    "lib.pupitre_added": "Part added",
    "lib.version_created": "Version created with its parts",
    "lib.class_partition": "PDF scores",
    "lib.class_audio": "Audio",
    "lib.class_video": "Videos",
    "lib.class_link": "Links",
    "lib.categories": "Categories",
    "lib.new_category": "New category",
    "lib.new_category_sr": "Create a piece category",
    "lib.category_name_placeholder": "Name (e.g. 2/4, Hornpipe, Suite…)",
    "lib.all_pieces": "All pieces",
    "lib.zone_bagad": "Bagad",
    "lib.zone_pipeband": "Pipe Band",
    "lib.discipline_label": "Discipline",
    "lib.discipline_common": "Shared (both)",
    "lib.all": "All",
    "lib.new_piece": "New piece",
    "lib.loading": "Loading library…",
    "lib.no_piece": "No pieces.",
    "lib.no_piece_create": " Create a category first.",
    "lib.versions_count": "version(s)",
    "lib.back_to_pieces": "Back to pieces",
    "lib.piece_fav": "Favorite piece",
    "lib.edit_piece": "Edit piece",
    "lib.delete_piece": "Delete piece",
    "lib.no_meta": "No metadata.",
    "lib.history_prefix": "History — ",
    "lib.version_fav": "Favorite version",
    "lib.rename_version": "Rename version",
    "lib.delete_version": "Delete version",
    "lib.no_version": "No versions.",
    "lib.no_version_hint": " Create a version and check the relevant parts.",
    "lib.pupitre_add": "+ Part",
    "lib.pupitre_prefix": "Part",
    "lib.rename_pupitre": "Rename part",
    "lib.remove_pupitre": "Remove part",
    "lib.no_file": "No files.",
    "lib.preview_empty_1": "Select a media",
    "lib.preview_empty_2": "to preview it",
    "lib.pdf_reader_sr": "PDF score viewer",
    "lib.new_pupitre": "New part",
    "lib.new_pupitre_sr": "Add a part to the selected version",
    "lib.group_instruments": "Group instruments",
    "lib.custom_name": "Custom name…",
    "lib.new_version": "New version",
    "lib.new_version_desc": "Check the parts (instruments) covered by this version.",
    "lib.version_name_placeholder": "Version name (e.g. 2026)",
    "lib.version_pupitres_label": "Parts — group instruments",
    "lib.no_instruments_hint": "No instruments defined — the administrator can add some in Settings → Group.",
    "lib.remove_named": "Remove {name}",
    "lib.custom_pupitre_placeholder": "Other part (custom)…",
    "lib.create_version": "Create version",
    "lib.rename_node_sr": "Rename the selected item",
    "lib.delete_desc": "“{name}” and all its content will be permanently deleted. There is no trash.",
    "lib.add_link_sr": "Add an external link (YouTube, website…)",
    "lib.delete_pupitre_files": "The part “{name}” contains {count} file(s). Deleting it will also delete these files. Do you want to continue?",
    "lib.delete_pupitre_empty": "Delete the part “{name}”? It contains no files.",
    "lib.download": "Download",
    "lib.share": "Share",
    "lib.print": "Print",
    "lib.link_copied": "Link copied to clipboard",

    // Settings
    "param.font_applied": "Text size applied",
    "param.profile_updated": "Profile updated",
    "param.pwd_mismatch": "Passwords do not match",
    "param.pwd_changed": "Password changed",
    "param.group_updated": "Group updated",
    "param.catimg_updated": "Category image updated",
    "param.logo_updated": "Logo updated",
    "param.instruments_updated": "Instruments updated",
    "param.subs_updated": "Subcategories updated",
    "param.axes_updated": "Work axes updated",
    "param.push_enabled": "Push notifications enabled on this device",
    "param.push_failed": "Activation failed",
    "param.theme_applied": "Theme applied",
    "param.sub_activated": "Subscription activated (simulated payment)",
    "param.eyedropper_unsupported": "The eyedropper is not supported by this browser",
    "param.tab_profile": "Profile",
    "param.tab_group": "Group",
    "param.tab_theme": "Theme",
    "param.tab_subscription": "Subscription",
    "param.my_profile": "My profile",
    "param.role_hint": "role assigned by the administrator",
    "param.instrument_one": "Instrument / Practice (only one)",
    "param.password": "Password",
    "param.pwd_current": "Current password",
    "param.pwd_new": "New password",
    "param.change_password": "Change password",
    "param.email_title": "Email address",
    "param.email_current": "Current address",
    "param.email_new": "New email address",
    "param.email_send_code": "Send me the verification code",
    "param.email_code_sent": "Code sent to {email}",
    "param.email_verify": "Confirm the change",
    "param.email_changed": "Email address updated!",
    "param.email_hint": "The code is sent to the new address. The old one receives a security notification.",
    "param.push_title": "Push notifications",
    "param.push_desc": "Alerts on this device, even when the app is closed.",
    "param.push_on": "Enabled",
    "param.push_denied": "Blocked by the browser",
    "param.cal_title": "Calendar sync",
    "param.cal_desc": "The whole group agenda right in your phone's calendar (iPhone, Android, Google Calendar…). Event changes appear automatically.",
    "param.cal_button": "Subscribe to calendar",
    "param.cal_hint": "The link opens in your device's Calendar app. You can also copy it to add it manually.",
    "param.cal_copied": "Subscription link copied",
    "param.push_unsupported": "Not supported here",
    "param.activate": "Activate",
    "param.notify_for": "Notify me for",
    "param.notif_pieces": "New pieces / media",
    "param.notif_documents": "New documents",
    "param.notif_events_created": "Events created",
    "param.notif_events_updated": "Events updated",
    "param.display": "Display",
    "param.font_size": "Text size",
    "param.font_size_hint": "The preview is immediate while adjusting; the size is only saved when you click Apply.",
    "param.apply": "Apply",
    "param.apply_caps": "APPLY",
    "param.group_identity": "Group identity",
    "param.logo_label": "Logo",
    "param.change_logo": "Change logo",
    "param.catimg_title": "Background images per event category",
    "param.catimg_desc": "Shown in the background of the dashboard's “Next event” card.",
    "param.change": "Change",
    "param.subs_title": "Event subcategories",
    "param.subs_desc": "Main categories are fixed; subcategories feed the calendar form. Existing events keep their label if a subcategory is deleted.",
    "param.sub_new_placeholder": "New subcategory ({cat})",
    "param.axes_title": "Work axes (programs)",
    "param.axes_desc": "Offered as shortcuts in the calendar's program editor.",
    "param.axis_new_placeholder": "New axis (e.g. Ensemble, Pipe…)",
    "param.instruments_title": "Group instruments / practices",
    "param.instrument_new_placeholder": "New instrument / practice",
    "param.theme_title": "Graphic customization",
    "param.theme_bg_app": "General background",
    "param.theme_bg_sidebar": "Navigation",
    "param.theme_bg_card": "Cards",
    "param.theme_text_primary": "Main text",
    "param.theme_text_secondary": "Secondary text",
    "param.theme_brand_primary": "Primary color",
    "param.theme_brand_accent": "Accent color",
    "param.theme_border_color": "Borders",
    "param.eyedropper": "Eyedropper",
    "param.theme_hint": "The preview is applied live. Confirm with APPLY to save it for the whole group.",
    "param.sub_title": "Group subscription",
    "param.sub_trial_status": "Free trial: {d} days left (ends on {date})",
    "param.plan_monthly": "monthly",
    "param.plan_yearly": "yearly",
    "param.sub_active_status": "{plan} subscription active until {date}",
    "param.sub_pastdue_1": "Subscription past due — grace period:",
    "param.sub_pastdue_2": "before access is suspended.",
    "param.grace_inner_s": "{d} day left",
    "param.grace_inner_p": "{d} days left",
    "param.sub_expired_status": "Subscription expired. Your data is kept: reactivate to regain full access.",
    "param.plan_monthly_name": "Monthly",
    "param.plan_yearly_name": "Yearly",
    "param.per_month": "/month",
    "param.per_year": "/year",
    "param.two_months_free": "2 months free",
    "param.payment_secure": "Secure payment by Stripe (bank card).",
    "param.payment_success": "Payment confirmed — subscription activated!",
    "param.payment_cancelled": "Payment cancelled.",
    "param.language_label": "Interface language",
    "param.language_hint": "Your personal language (default: the group's language).",

    // Wheel / piece form
    "wheel.validate": "Confirm",
    "pfs.composer": "Composer",
    "pfs.duration": "Duration",
    "pfs.set_duration": "Set the duration",
    "pfs.tempo": "Tempo (BPM)",
    "pfs.set_tempo": "Set the tempo",
    "pfs.description": "Description",
    "pfs.history": "History",
    "pfs.category": "Category",
    "pfs.tag_placeholder": "Add a tag",
    "pfs.add_tag": "Add the tag",
    "pfs.save_changes": "Save changes",
    "pfs.create_piece": "Create piece",
    "pfs.initial_version": "Initial version",
    "pfs.version_default": "Version",
    "pfs.pupitres_label": "Parts concerned",

    // Super-admin
    "sa.st_trial": "Trial",
    "sa.my_accounts": "My accounts",
    "sa.no_other_account": "No other signed-in account on this device.",
    "sa.kpi_groups": "Groups",
    "sa.kpi_active": "Active subs",
    "sa.kpi_trial": "On trial",
    "sa.kpi_expired": "Expired / suspended",
    "sa.kpi_members": "Members",
    "sa.kpi_mrr": "Est. monthly revenue",
    "sa.kpi_active_7d": "Active 7 d",
    "sa.kpi_active_30d": "Active 30 d",
    "sa.search_group": "Search groups (name, @slug)…",
    "sa.export_csv": "Export (CSV)",
    "sa.activity_title": "Activity log",
    "sa.activity_signups": "Latest signups",
    "sa.activity_payments": "Latest subscription payments",
    "sa.activity_empty": "No recent activity.",
    "sa.impersonate": "View as (support)",
    "sa.impersonate_confirm": "Open?",
    "sa.impersonate_q": "Open a support session on this group? The action is logged.",
    "sa.delete_group_q": "Permanently delete this group and all its data? This cannot be undone.",
    "sa.delete_space_q": "Permanently delete this teaching space? This cannot be undone.",
    "sa.users_activity_title": "Users — last activity",
    "sa.users_activity_subtitle": "Date and time of each user's last use of the app (tracked live).",
    "sa.search_user": "Search a user, a group…",
    "sa.col_member": "Member",
    "sa.col_group": "Group",
    "sa.col_last_seen": "Last activity",
    "sa.never_seen": "Never",
    "sa.teaching_title": "Teaching spaces ({n})",
    "sa.teaching_subtitle": "Educator accounts: view spaces and members, delete spaces. Teaching content is not accessible here.",
    "sa.col_space": "Space",
    "sa.col_owner": "Teacher",
    "sa.col_students": "Students",
    "sa.col_classes": "Classes",
    "sa.teaching_empty": "No teaching spaces yet.",
    "sa.space_deleted": "Space “{name}” permanently deleted",
    "sa.search_space": "Search a space (name, teacher, @handle)…",
    "sa.st_active": "Active",
    "sa.st_past_due": "Past due (grace)",
    "sa.st_expired": "Expired",
    "sa.st_suspended": "Suspended",
    "sa.action_done": "Action applied",
    "sa.group_deleted": "Group “{name}” permanently deleted",
    "sa.delete_account": "Delete account",
    "sa.delete_account_q": "Permanently delete this account, its personal space and all its data? This cannot be undone.",
    "sa.account_deleted": "Account “{name}” permanently deleted",
    "sa.title": "Platform administration",
    "sa.groups_title": "Groups ({n})",
    "sa.members_title": "Personal spaces ({n})",
    "sa.members_subtitle": "Members' personal spaces: support session, suspension, deletion.",
    "sa.kpi_teaching": "Teaching",
    "sa.col_firstname": "First name",
    "sa.col_lastname": "Last name",
    "sa.col_email": "Email",
    "sa.ensure_personal": "Create / repair spaces",
    "sa.ensure_personal_done": "Personal spaces: {n} total, {r} duplicate(s) removed",
    "sa.suspend_space": "Suspend space",
    "sa.unsuspend_space": "Reactivate space",
    "sa.subtitle": "Manage suspensions and deletions. The groups' musical content is not accessible here.",
    "sa.col_members": "Members",
    "sa.col_created": "Created on",
    "sa.extend7": "Extend trial by 7 days",
    "sa.extend30": "Extend trial by 30 days",
    "sa.activate_monthly": "Activate monthly subscription",
    "sa.activate_yearly": "Activate yearly subscription",
    "sa.unsuspend": "Reactivate group",
    "sa.suspend": "Suspend group",
    "sa.view_members": "View members",
    "sa.confirm_q": "Confirm?",
    "sa.monthly_caps": "Monthly",
    "sa.yearly_caps": "Yearly",
    "sa.empty": "No groups yet.",

    // Inventory
    "inv.loan_saved": "Loan saved",
    "inv.just_added": "Receipt attached",
    "inv.date_updated": "Loan date updated",
    "inv.popup_blocked": "Allow pop-up windows to print",
    "inv.print_date": "Issued on",
    "inv.print_footnote": "✓ owned · G loaned by the group · — not owned",
    "inv.family_tenue": "Outfit",
    "inv.family_instrument": "Instrument",
    "inv.family_materiel": "Equipment",
    "inv.origin_personnel": "Personal",
    "inv.origin_loaned": "Loaned by the group",
    "inv.owned": "Owned",
    "inv.not_owned": "Not owned",
    "inv.view_mine": "My view",
    "inv.view_all": "Full view",
    "inv.tab_loans": "Loans",
    "inv.new_item_placeholder": "New item (e.g. Bagpipes)",
    "inv.cat_obligatoire": "Mandatory",
    "inv.cat_facultatif": "Optional",
    "inv.print": "Print / PDF",
    "inv.item_col": "Item",
    "inv.complete": "Complete",
    "inv.no_items": "No inventory items.",
    "inv.no_items_admin": " Add the first item above.",
    "inv.loans_title": "Equipment loaned by the group",
    "inv.new_loan": "New loan",
    "inv.material": "Equipment",
    "inv.loan_date": "Loan date",
    "inv.justificatif": "Receipt",
    "inv.status": "Status",
    "inv.view": "View",
    "inv.attach": "Attach",
    "inv.returned": "Returned",
    "inv.ongoing": "On loan",
    "inv.no_loans": "No loans recorded.",
    "inv.missing_title": "Missing items",
    "inv.delete_item_title": "Delete the item?",
    "inv.delete_item_desc": "“{name}” will be permanently removed from the inventory.",
    "inv.delete_loan_title": "Delete the loan?",
    "inv.delete_loan_desc": "The loan “{name}” will be permanently deleted.",
    "inv.other_free": "Other (free text)",
    "inv.specify_material": "Specify the equipment",
    "inv.recipient": "Recipient member",
    "inv.save_loan": "Save loan",

    // Login (extras)
    "login.group_created": "Group created! Your ID: {id}",
    "login.migrate_title": "Link your email address",
    "login.legacy_removed": "This login belonged to the former sign-in system. Ask your group for a new invitation.",
    "auth.create_space": "+ Create a new space",
    "layout.create_space": "Create a space",
    "layout.platform_section": "Platform",
    "layout.platform_console": "Platform console",
    "layout.platform_console_desc": "RANNEA administration",
    "login.space_personal": "Personal account",
    "login.space_personal_desc": "Your private space: library, documents, favorites",
    "join.card_title": "Join a group",
    "join.card_desc": "Enter the group's exact name. The group's administrator will receive your request and can accept or decline it.",
    "join.name_placeholder": "Exact group name",
    "join.send": "Send",
    "join.sent": "Request sent to the group",
    "join.my_requests": "My requests",
    "join.status_pending": "Pending",
    "join.status_accepted": "Accepted",
    "join.status_declined": "Declined",
    "join.admin_title": "Join requests",
    "join.accept": "Accept",
    "join.decline": "Decline",
    "join.accepted_toast": "Request accepted — the member has joined the group",
    "join.declined_toast": "Request declined",
    "space.create_title": "Create a new space",
    "space.create_sub": "Music group or teaching space — it will appear in your space switcher.",
    "space.created": "Space created!",
    "space.personal_ready": "Your personal space will be created automatically: store your sheet music, documents and favorites, and request to join a group from the settings.",
    "login.migrate_intro": "RANNEA is moving to email sign-in. Enter your address: you will receive a verification code. Your current password will be kept, and if you already have a RANNEA account with this address, your access will be merged.",
    "login.migrate_email_label": "Your email address",
    "login.migrate_send": "Send me the code",
    "login.migrate_code_label": "Code received by email (6 digits)",
    "login.migrate_submit": "Confirm and migrate my account",
    "login.migrate_sent": "Code sent to {email}",
    "login.migrate_done": "Account migrated — welcome!",
    "login.migrate_cancel": "Back",
    "login.migrate_resend": "Resend code",
    "login.account_activated": "Account activated, welcome!",
    "auth.email_label": "Email address",
    "auth.email_ph": "thomas.dupont@gmail.com",
    "auth.pwd_rule": "8 characters minimum.",
    "auth.your_account": "Your account",
    "auth.your_group": "Your group",
    "auth.create_account": "Create my account",
    "auth.verify_title": "Verify your email address",
    "auth.verify_sub": "We sent a code to:",
    "auth.code_label": "Code digit",
    "auth.code_incomplete": "Enter the 6-digit code.",
    "auth.confirm": "Confirm",
    "auth.resend": "Resend the code",
    "auth.resend_wait": "Resend the code ({s}s)",
    "auth.code_resent": "Code resent — check your inbox.",
    "auth.email_verified": "Email address verified!",
    "auth.my_groups": "My groups",
    "auth.choose_group_sub": "Choose the space to open:",
    "auth.no_group_title": "No group yet",
    "auth.no_group_sub": "Create your group below, or wait for an invitation from an existing group.",
    "auth.forgot_title": "Reset my password",
    "auth.forgot_sub": "Enter the email address of your RANNEA account.",
    "auth.send_link": "Send the link",
    "auth.forgot_sent": "If a RANNEA account matches this address, you will receive an email to reset your password.",
    "auth.back_to_login": "Back to sign in",
    "auth.reset_title": "New password",
    "auth.new_password": "New password",
    "auth.reset_save": "Save",
    "auth.reset_done": "Password updated — you can sign in now.",
    "auth.reset_ask_again": "Expired link? Ask for a new one",
    "usr.send_invitation": "Send invitation",
    "usr.invitation_sent_msg": "Invitation sent — the member will receive an email to create their account or join the group.",
    "usr.pending_invitations": "Pending invitations",
    "usr.invitation_pending": "invitation pending",
    "usr.resend_invitation": "Resend",
    "usr.cancel_invitation": "Cancel",
    "usr.invitation_resent": "Invitation resent",
    "usr.invitation_cancelled": "Invitation cancelled",
    "inv.loading": "Loading invitation…",
    "inv.invalid": "This invitation link is invalid.",
    "inv.expired": "This invitation has expired. Ask your group for a new link.",
    "inv.cancelled": "This invitation was cancelled.",
    "inv.accepted": "This invitation has already been accepted.",
    "inv.title": "You are invited!",
    "inv.for": "Invitation for",
    "inv.invited_by": "Invited by {name}",
    "inv.join_button": "Join the group",
    "inv.logged_as": "Signed in as {email}",
    "inv.existing_account": "You already have a RANNEA account — sign in to accept the invitation.",
    "inv.login_button": "Sign in",
    "inv.create_account": "Create your account to join the group:",
    "inv.create_and_join": "Create my account and join",
    "inv.welcome": "Welcome to {name}!",
    "inv.wrong_logout": "Sign out and switch account",
    "inv.back_login": "Go to sign in",
    "login.custom_style_placeholder": "Orchestra, Brass band…",

    // Media player
    "mp.ab_error": "Place point A before point B",
    "mp.marker_updated": "Marker updated",
    "mp.marker_added": "Marker added",
    "mp.label_renamed": "Label renamed",
    "mp.label_deleted": "Label deleted",
    "mp.marker_edit": "Edit marker",
    "mp.marker_add_title": "Add a marker",
    "mp.marker_dialog_sr": "Name and adjust the marker position",
    "mp.current_position": "Current position",
    "mp.marker_placeholder": "E.g. 1st phrase",
    "mp.labels": "Labels",
    "mp.manage": "Manage",
    "mp.manage_done": "Done",
    "mp.confirm_rename": "Confirm rename",
    "mp.rename_named": "Rename {name}",
    "mp.delete_named": "Delete {name}",
    "mp.player_sr": "Media player",
    "mp.processing": "Converting — optimized playback starts automatically once ready.",
    "mp.unsupported": "This format ({ext}) cannot be played directly in this browser.",
    "mp.retry": "Retry",
    "mp.download": "Download the file",
    "mp.clear_loop": "Clear loop",
    "mp.exit_fullscreen": "Exit fullscreen",
    "mp.speed": "Speed",
    "mp.now_playing": "Now playing",
    "mp.markers": "Markers",
    "mp.audio_player": "Audio player",
    "mp.parties": "Sections",
    "mp.loop": "Loop",
    "mp.share": "Share",
    "mp.expand": "Expand player",
    "mp.stop": "Stop playback",
    "mp.marker_add": "Add a marker",
    "mp.no_markers": "No markers yet.",

    // Tutorial
    "tut.s1_title": "Welcome to RANNEA",
    "tut.s1_desc": "Your whole music group in one place: sheet music, audio, video, calendar, attendance and inventory.",
    "tut.s2_title": "Library",
    "tut.s2_desc": "PDF scores, audio and video organized by category, piece, version and part. Built-in player with speed, A-B loop and markers.",
    "tut.s3_title": "Calendar & attendance",
    "tut.s3_desc": "Upcoming rehearsals and performances; set your availability in one click, right from the dashboard.",
    "tut.s4_title": "Setlists & favorites",
    "tut.s4_desc": "Build performance programs and find your favorite pieces instantly.",
    "tut.s5_title": "Inventory & loans",
    "tut.s5_desc": "Declare your equipment, track mandatory outfits and group loans.",
    "tut.s6_title": "Administrator area",
    "tut.s6_desc": "Create member accounts, manage instruments, subcategories, theme and subscription from Settings.",
    "tut.p1_title": "Library",
    "tut.p1_desc": "Your personal PDF scores, audio and video, organized by category. Built-in player with speed, A-B loop and markers.",
    "tut.p2_title": "Documents",
    "tut.p2_desc": "Keep your personal documents in folders, and download them for offline access.",
    "tut.p3_title": "Favorites",
    "tut.p3_desc": "Instantly find the pieces and files you marked with a heart.",
    "tut.p4_title": "Settings",
    "tut.p4_desc": "Manage your profile, display and offline mode — and request to join a group from the Group tab.",
    "tut.skip": "Skip intro",
    "tut.next": "Next",
    "tut.start": "Let's go!",
    "tut.counter": "{i} / {n}",
    "param.tutorial_title": "Discovery tutorial",
    "param.tutorial_desc": "Revisit the presentation of the app's modules.",
    "param.tutorial_button": "Replay the tutorial",

    // Membership fees (separate from the RANNEA subscription)
    "fees.tab": "Fees",
    "fees.readonly_note": "Informational module: no payment is made in the app for now.",
    "fees.col": "Fee",
    "fees.summary_concerned": "members concerned",
    "fees.summary_paid": "up to date",
    "fees.summary_due": "to pay",
    "fees.summary_exempt": "exempt / not concerned",
    "fees.expected": "Total expected",
    "fees.received": "Total received",
    "fees.remaining": "Remaining",
    "fees.filter_all_status": "All statuses",
    "fees.filter_all_instruments": "All instruments",
    "fees.status_paid": "Up to date",
    "fees.status_due": "To pay",
    "fees.status_pending": "Payment pending",
    "fees.status_exempt": "Exempt",
    "fees.status_not_applicable": "Not concerned",
    "fees.mark_paid": "Mark as paid",
    "fees.mark_paid_title": "Record the payment",
    "fees.paid_at": "Payment date",
    "fees.method": "Payment method",
    "fees.method_especes": "Cash",
    "fees.method_cheque": "Cheque",
    "fees.method_virement": "Bank transfer",
    "fees.method_autre": "Other",
    "fees.method_en_ligne": "Online payment",
    "fees.comment": "Comment (optional)",
    "fees.amount_paid": "Amount paid (€)",
    "fees.edit_title": "Member's fee",
    "fees.status_label": "Status",
    "fees.amount_due": "Amount due (€)",
    "fees.notes": "Administrator comment",
    "fees.remind": "Remind members not up to date",
    "fees.remind_done": "Reminder sent to {n} member(s)",
    "fees.remind_none": "All fees are up to date",
    "fees.empty": "No fee period. Create it in Settings > Fees.",
    "fees.paid_on": "Paid on {date}",
    "fees.updated": "Fee updated",
    "feescfg.enable": "Enable membership fee tracking",
    "feescfg.rib_title": "Group bank details (visible to members)",
    "feescfg.rib_holder": "Account holder",
    "feescfg.rib_iban": "IBAN",
    "feescfg.rib_bic": "BIC",
    "feescfg.rib_save": "Save bank details",
    "feescfg.alert": "Reminder popup at login",
    "feescfg.alert_hint": "Shows members an “outstanding fee” popup at login (max once a day).",
    "feescfg.periods_list": "Existing periods",
    "feescfg.edit_period": "Edit period",
    "feescfg.delete_period_q": "Delete this period and all its fees? This cannot be undone.",
    "feescfg.period_updated": "Period updated",
    "feescfg.period_deleted": "Period deleted",
    "feescfg.amount_note": "The new amount applies to fees still marked “due” (payments already made or declared are unchanged).",
    "fees.rib_title": "Pay by bank transfer",
    "fees.copy": "Copy",
    "fees.copied": "Copied to clipboard",
    "feescfg.enable_hint": "When disabled, members no longer see the fee card; the administration keeps access.",
    "feescfg.new_period": "New fee period",
    "feescfg.name": "Name (e.g. Annual fee 2026 / 2027)",
    "feescfg.amount": "Amount (€)",
    "feescfg.due_date": "Payment deadline",
    "feescfg.description": "Description (optional)",
    "feescfg.create": "Create period",
    "feescfg.created": "Period created — fees generated for all active members",
    "feescfg.periods": "Periods",
    "feescfg.current": "Current",
    "feescfg.set_current": "Set as current",
    "feescfg.config_saved": "Configuration saved",
    "myfees.title": "My membership fee",
    "myfees.banner_title": "Membership fee due",
    "myfees.claim_paid": "I paid by bank transfer",
    "myfees.claim_done": "Thank you! The admin will confirm upon receipt.",
    "myfees.later": "Later",
    "fees.add_cotisation": "Add a fee",
    "fees.add_title": "New fee",
    "fees.member": "Member",
    "fees.delete_title": "Delete fee",
    "fees.delete_q": "Permanently delete this fee? This cannot be undone.",
    "fees.deleted": "Fee deleted",
    "fees.added": "Fee added",
    "fees.all_have_fee": "All active members already have a fee for this period",
    "fees.instrument_of": "Practice / instrument",
    "myfees.due_date": "To be paid before {date}",
    "myfees.pay": "Pay my fee",
    "myfees.paid_on": "Paid on {date} ({method})",
    "myfees.history": "History",
    "myfees.none": "No fees yet.",
    "myfees.payment_success": "Fee paid — thank you!",
    "myfees.payment_cancelled": "Payment cancelled.",
    "myfees.test_mode": "Online payment in test mode (Stripe).",
    "myfees.pending_hint": "Payment declared — pending admin confirmation.",
    "param.disciplines_label": "Disciplines practised",
    "param.disciplines_hint": "Tick both if the group practises both disciplines: the library will show a “Bagad” zone and a “Pipe Band” zone.",
    "login.space_type_label": "Space type",
    "login.space_band": "Music group",
    "login.space_band_desc": "Pipe Band, Bagad, ensemble…",
    "login.space_school": "Teaching",
    "login.space_school_desc": "Teachers & students space",
    "login.space_dev": "In development",
    "login.teacher_profile": "Your teacher profile",
    "login.space_name": "Teaching space name",
    "teach.nav_students": "My students",
    "teach.nav_classes": "My classes",
    "teach.nav_my_classes": "My classes",
    "teach.students_title": "My students",
    "teach.classes_title": "My classes",
    "teach.add_student": "Add a student",
    "teach.add_student_desc": "The generated ID (firstname@space) must be given to the student for their first sign-in.",
    "teach.student_created": "Student created — ID to share: {login}",
    "teach.search_student": "Search a student…",
    "teach.no_students": "No students yet",
    "teach.no_classes": "No classes yet",
    "teach.no_class_student": "You are not enrolled in any class yet.",
    "teach.add_class": "Create a class",
    "teach.class_name": "Class name",
    "teach.description": "Description",
    "teach.level": "Level",
    "teach.notes": "Teaching notes",
    "teach.members": "Members",
    "teach.add_member": "Add a student",
    "teach.remove_member": "Remove",
    "teach.delete_class": "Delete the class",
    "teach.delete_class_desc": "The class and its enrolments will be deleted. Student accounts, individual relations and other classes are kept.",
    "teach.pending_account": "Account to activate",
    "teach.account_active": "Active account",
    "teach.inactive_relation": "Inactive relation",
    "teach.deactivate_relation": "Deactivate the relation",
    "teach.reactivate_relation": "Reactivate the relation",
    "teach.my_space": "My space",
    "teach.student_sheet": "Student record",
    "teach.saved": "Saved",
    "teach.see_all": "See all",
    "teach.member_count_s": "{n} student",
    "teach.member_count_p": "{n} students",
    "teach.nav_agenda": "Schedule",
    "teach.nav_lessons": "My lessons",
    "teach.add_lesson": "Create a lesson",
    "teach.edit_lesson": "Edit the lesson",
    "teach.lesson_type": "Lesson type",
    "teach.lesson_individual": "Individual lesson",
    "teach.lesson_class": "Class lesson",
    "teach.lesson_student": "Student",
    "teach.lesson_class_label": "Class",
    "teach.lesson_date": "Date",
    "teach.lesson_time": "Time",
    "teach.lesson_duration": "Duration (min)",
    "teach.lesson_notes": "Lesson notes",
    "teach.next_lesson": "Next lesson",
    "teach.no_lessons": "No lessons scheduled",
    "teach.upcoming_lessons": "Upcoming lessons",
    "teach.past_lessons": "Past lessons",
    "teach.minutes": "{n} min",
    "teach.delete_lesson": "Delete the lesson",
    "teach.delete_lesson_desc": "This lesson will be permanently deleted.",
    "teach.lesson_created": "Lesson created",
    "teach.lessons_history": "Lesson history",
    "teach.class_lessons": "Class lessons",
    "teach.nav_resources": "Resources",
    "teach.my_resources": "My resources",
    "teach.resources_title": "Teaching resources",
    "teach.add_resource": "Add a resource",
    "teach.resource_title": "Title",
    "teach.resource_file": "File",
    "teach.resource_or_link": "or an external link",
    "teach.resource_url": "Link (URL)",
    "teach.resource_shared": "Shared",
    "teach.resource_not_shared": "Not shared",
    "teach.share": "Share",
    "teach.share_title": "Share “{name}”",
    "teach.share_students": "Students",
    "teach.share_classes": "Classes",
    "teach.no_resources": "No resources yet",
    "teach.no_resources_student": "No resources shared with you yet.",
    "teach.download": "Download",
    "teach.open_link": "Open the link",
    "teach.delete_resource": "Delete the resource",
    "teach.delete_resource_desc": "The resource and all its shares will be deleted. Students and classes are kept.",
    "teach.type_pdf": "PDF",
    "teach.type_score": "Score",
    "teach.type_image": "Image",
    "teach.type_audio": "Audio",
    "teach.type_video": "Video",
    "teach.type_document": "Document",
    "teach.type_link": "Link",
    "mp.play": "Play",
    "teach.recent_resources": "Recent resources",
    "teach.shared_resources": "Shared resources",
    "teach.class_resources": "Class resources",
    "teach.quick_share": "Share a resource",
    "teach.uploading": "Uploading…",
    "teach.nav_assignments": "Assignments",
    "teach.assignments_title": "Assignments",
    "teach.add_assignment": "Create an assignment",
    "teach.edit_assignment": "Edit the assignment",
    "teach.assignment_target": "Recipient",
    "teach.due_date": "Due date",
    "teach.no_due": "No due date",
    "teach.linked_resources": "Linked resources",
    "teach.mark_done": "Mark as done",
    "teach.mark_todo": "Mark as to do",
    "teach.done_badge": "Done",
    "teach.todo_badge": "To do",
    "teach.overdue": "Overdue",
    "teach.done_count": "{done}/{total} done",
    "teach.no_assignments": "No assignments yet",
    "teach.no_assignments_student": "Nothing to do. Well done!",
    "teach.delete_assignment": "Delete the assignment",
    "teach.delete_assignment_desc": "This assignment will be deleted. Linked resources stay in your library.",
    "teach.assignment_created": "Assignment created",
    "teach.assignment_dialog_desc": "Create an assignment for a student or a class, with optional due date and resources.",
    "teach.to_follow": "Work to follow up",
    "teach.done_section": "Done",
    "teach.todo_section": "To do",
    "teach.for_student": "Individual",
    "teach.for_class": "Class",
  },
};

export function translate(lang, key, vars) {
  let s = translations[lang]?.[key] ?? translations.fr[key] ?? key;
  if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.replaceAll(`{${k}}`, String(v)); });
  return s;
}

export const dateLocale = (lang) => (lang === "en" ? "en-GB" : "fr-FR");
